/*** Pre Declare Filter Arrays ***/
const cut_array = {"Excellent": "Excellent","Very Good": "Very Good","Good": "Good"};
const cut_array_lab = {"Excellent": "Excellent","Very Good": "Very Good","Good": "Good"};

const polish_array = {"Excellent": "Excellent","Very Good": "Very Good","Good": "Good"};

const symmetry_array = {"Excellent": "Excellent","Very Good": "Very Good","Good": "Good"};

const fluorescence_array = {"None": "None", "Faint": "Faint", "Medium": "Medium","Strong": "Strong","Very Strong": "Very Strong"};

const clarity_array = {"FL": "FL","IF": "IF","VVS1": "VVS1","VVS2": "VVS2","VS1": "VS1","VS2": "VS2","SI1": "SI1","SI2": "SI2"};

const color_array = {"D": "D","E": "E","F": "F","G": "G","H": "H","I": "I","J": "J","K": "K","L": "L"};

const intensity_array = {"Light":"Light","Fancy":"Fancy","Intense":"Intense","Vivid":"Vivid","Deep":"Deep","Dark":"Dark"};

const lab_process_array = {"CVD":"Chemical Vapor Deposition Process", "HPHT":"High Pressure And High Temperature"};

var diaListViewBulkData = '';
var diaGridViewBulkData = '';
/*** End ***/

/**** Advanced Filter Functionality Start ****/  
$(document).on("click", ".tps-advanced-filter-btn", function() {
    var filter_category = jQuery(this).attr("data-category");
    
    if(jQuery(this).hasClass("active")){
      jQuery(this).removeClass("active");
      jQuery('.tps-advanced-filter-btn').html(translations.titleAdvancedFilters+' <span class="tps-icon-plus"></span>'); 
      jQuery('.tps-filter-'+filter_category).slideUp('slow');    
    }else{
      jQuery(this).addClass("active");
      jQuery('.tps-advanced-filter-btn').html(translations.titleAdvancedFilters+' <span class="tps-icon-cross"></span>');      
      jQuery('.tps-filter-'+filter_category).slideDown('slow');    
    }      
});
/*** End ***/

/*** Reset Filter Popoup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-advanced-reset-button-section");
  var container2 = $(".tps-tab2");
  var container3 = $(".tps-add-fields-settings");
  var container4 = $('.tps-reset-popup');
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0 && !container3.is(e.target) && container3.has(e.target).length === 0 && !container4.is(e.target) && container4.has(e.target).length === 0){     
    jQuery(".tps-reset-filter-confirm-popup-div").hide();
    jQuery(".tps-popup-adding-filter-list-view").css("display","none");
  }
});
/*** Reset Filter Popoup Close Outer Click End ***/

/**** Mobile Filter Open/Close Start ****/ 
function mobileFilters(action, e) {
  if (e) {
    e.stopPropagation();
  }

  if (action === 'open') {
    $('.tps-filter-container').addClass('tps-mobile-filters');
    $('body').addClass('tps-mobile-filters-open');
  } else {
    $('.tps-filter-container').removeClass('tps-mobile-filters');
    $('body').removeClass('tps-mobile-filters-open');
  }
}
/*** End ***/

/*** Mobile Filter Close onClick Overly Start ***/
jQuery(document).on('click','.tps-mobile-filters',function(e){
  var container = $(".tps-filter-tabs-container");
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    mobileFilters('close');
  }
});
/*** Mobile Filter Close onClick Overly End ***/

/**** Mobile Filter Button Sticky Start ****/ 
$(window).scroll(function(){
    if ($(this).scrollTop() > 500) {
       $('.tps-mobile-filter-button-section').addClass('tps-sticky-btn');
    } else {
       $('.tps-mobile-filter-button-section').removeClass('tps-sticky-btn');
    }
});

/*** End ***/

/**** Tooltip Information Open/Close Start ****/ 
function infoPopup(diamondField,action){  
  if(action == 'open'){
    $(".tps-diamond-field-"+diamondField).addClass('tps-popup-info-show');    
  }else{
    $(".tps-diamond-field-"+diamondField).removeClass('tps-popup-info-show');    
  }  
}

function tpsInfoPopup(field, action) {

    // Remove active class from all popup cards
    $('.tps-diamond-info-card').removeClass('active');

    if (action === 'open') {

        // diamond-color -> color
        var popupClass = field.replace('diamond-', '');

        $('.tps-diamond-info-card-' + popupClass).addClass('active');

        $('.tps-popup-overlay').addClass('active'); // Optional: open modal
    } else {

        $('.tps-popup-overlay').removeClass('active');
    }
}
/**** Tooltip Information Open/Close End ****/ 

/*** Diamond Filter Tooltip Info Popoup Close Outer Click Start ***/
jQuery(document).on('click','.tps-popup-info-show',function(e){
  var container = $(".tps-diamond-field-popup-section");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){      
    jQuery(".tps-diamond-field-popup-wrapper").removeClass("tps-popup-info-show");
  }
});
/*** Diamond Filter Tooltip Info Popoup Close Outer Click End ***/

/*** CheckBox Type Filter Selection Common Function Start (multiselect filters) ***/
function setCheckboxtypeFilter(ele,parentClass,valueid,filter){     
   var filter_value = jQuery(ele).find("input").attr('data-value');
   emptyResultDiv();

    var check_variable='';      
      if(jQuery(ele).hasClass('selected')){
        jQuery(ele).removeClass('selected');
      }else{
        jQuery(ele).addClass('selected');
      }
      
      jQuery("."+parentClass+" input:checkbox" ).each(function(){
        if(jQuery(this).is(':checked')){
          if(check_variable==""){
            check_variable = jQuery(this).attr('value'); 
          }else{
            check_variable = check_variable+","+jQuery(this).attr('value');
          }            
        }
      });    

      if(check_variable==''){
        $('#'+valueid).val('');
      }else{      
        $('#'+valueid).val(check_variable);
      }
    
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');
    graphqlDataCall();    
    updateSessionFilters(session_variable+'-filters',filter, check_variable);
  
    //Applied filter code start 
    var filterTitle = filter+': '+filter_value;    
    var filterFunction = "remove"+filter+"Filter('"+filter_value+"')"; 
    var hasClass = jQuery(ele).hasClass('selected');
    setSelectedFilter(filterTitle,filterFunction,hasClass,filter_value);
    //end
  
    // cut filter visibility according to shape selection 
    if(valueid == 'dia_shape'){
      setCutFilterVisibility(check_variable);
    }

    //change page heading according to fancy color selection start
    if(valueid == 'dia_fancy_color'){      
      changePageHeadingAccordingToColor(check_variable);
    }
    //change page heading according to fancy color selection end
 
}
/*** End ***/

/*** Change Page Heading According To Color Filter For Colour Diamond Pages Start ***/
function changePageHeadingAccordingToColor(check_variable){
    var colorArray = check_variable;
    
    var selectedColors = colorArray.split(','); 
    var lastSelectedColor = selectedColors[selectedColors.length - 1];           
    pageTitleArray = pageTitle.split(' ');
    var previousSelectedColor = pageTitleArray[pageTitleArray.length - 2];
    if(lastSelectedColor == ''){
        lastSelectedColor = 'Colour';
    }
    var pageHeading = pageTitle.replace(previousSelectedColor,lastSelectedColor);
    jQuery('.tps-diamond-page-heading').text(pageHeading);        
}
/*** End ***/

/*** Only Letters And Numbers Conversion Start ***/
function onlyLettersAndNumbers(str) {
    return /^[A-Za-z0-9]*$/.test(str);
}
/*** End ***/

/*** Set Cut Filter Visibilty Start ***/
function setCutFilterVisibility(shapes) {  
  if(shapes.indexOf("Round") >= 0){
    jQuery('.tps-filter-cut').show();
  }else if(shapes == ''){
    jQuery('.tps-filter-cut').show();
  }else{
    jQuery('.tps-filter-cut').hide();

    $('#cut_min_value').val(0);
    $('#cut_max_value').val(default_max_cut);
    var filterLabel = translations.titleCut;

    cut_slider_render(0, default_max_cut, true, filterLabel);
  }
}
/*** End ***/

/*** Remove Shape Filter From Applied Filter Start ***/
function removeShapeFilter(shape){ 
  jQuery('.tps-filter-shape-list input[data-value="'+shape+'"]').click();
}
/*** Remove Shape Filter From Applied Filter End ***/

/*** Remove Fancy COlor Filter From Applied Filter Start ***/
function removeColorFilter(color){ 
  jQuery('.tps-filter-fancy-color-list input[data-value="'+color+'"]').click();
}
/*** Remove Fancy COlor Filter From Applied Filter End ***/

/*** Remove Report Filter From Applied Filter Start ***/
function removeCertificateFilter(lab){  
  jQuery('.tps-filter-report-list input[data-value="'+lab+'"]').click();
}
/*** Remove Report Filter From Applied Filter End ***/

/*** Color Range Slider Filter Start ***/
var _gql_debounce_timer = null;
function debouncedGraphqlDataCall(delay){
  delay = (typeof delay === 'number') ? delay : 50;
  if(_gql_debounce_timer){
    clearTimeout(_gql_debounce_timer);
  }
  _gql_debounce_timer = setTimeout(function(){
    _gql_debounce_timer = null;
    graphqlDataCall();
  }, delay);
}

function createSwatchFilter(filterKey, maxVarName, opts){
  opts = opts || {};
  var wrapSelector = opts.wrapSelector || ('#tps_' + filterKey + '_wrap');  
  var listSelector = opts.listSelector || ('.tps-' + filterKey + '-list.tps-slider-list');
  var minInputId   = opts.minInputId   || (filterKey + '_min_value');
  var maxInputId   = opts.maxInputId   || (filterKey + '_max_value');

  var state = {
    anchor_index: null,
    last_index:   null,
    filter_title: '',
    filter_loaded: false
  };

  function getMax(){
    return window[maxVarName];
  }

  function render(start, end, option, filterTitle, forceSelected){

    var default_max = getMax();

    if(typeof default_max === 'undefined'){
      console.warn('[createSwatchFilter] "' + maxVarName + '" is undefined — ' +
        'check that this global is declared before ' + filterKey + '_slider_render runs. ' +
        'Skipping render to avoid falsely marking "' + filterKey + '" as applied.');
      return;
    }

    state.filter_title = filterTitle;
    var isFirstLoad = !state.filter_loaded;
    state.filter_loaded = true;

    // Only treat a (0, default_max) render as "clear everything" when it came from
    // an explicit reset (reset button / remove-filter chip), NOT from a swatch click
    // that happens to span the full range (e.g. clicking D then L) — that's a real
    // user selection and forceSelected will be true in that case.
    if(!forceSelected && start == 0 && end == default_max){
      state.anchor_index = null;
      state.last_index   = null;
    }
    if(state.anchor_index === null && (start != 0 || end != default_max)){
      state.anchor_index = Number(start) + 1;
      state.last_index   = end;
    }

    jQuery('#' + minInputId).val(start);
    jQuery('#' + maxInputId).val(end);

    var filterLable = filterTitle + ':';

    var isSelected = forceSelected ? true : (start != 0 || end != default_max);

    var selected_values = getFilterValues(start, end, filterKey);

    var filterValues;
    if(selected_values[0] == selected_values[1]){
      filterValues = filterLable + ' ' + selected_values[1];
    }else{
      filterValues = filterLable + ' ' + selected_values[0] + ' - ' + selected_values[1];
    }

    setSelectedFilter(
      filterValues,
      filterKey + "_slider_render('0', '" + default_max + "','false','" + filterTitle + "')",
      isSelected,
      filterKey
    );

    highlightLabels(start, end, isFirstLoad, isSelected);

    var resetFlag = checkResetFlag();
    emptyResultDiv();

    updateSessionFilters(session_variable + '-filters', filterTitle, start + ',' + end);

    if(resetFlag != 'true'){
      jQuery('#page_no').val(1);
      jQuery('#pagination').val('');
      debouncedGraphqlDataCall();
    }
  }

  function highlightLabels(start, end, isFirstLoad, isSelected){
    var default_max = getMax();

    jQuery(wrapSelector + ' ' + listSelector + ' li').removeClass('selected');

    if(isFirstLoad && start == 0 && end == default_max){
      return;
    }

    for(var k = 1; k <= default_max; k++){
      if((k - 1) >= start && k <= end){
        if(isSelected == true){
          jQuery(wrapSelector + ' ' + listSelector + ' li[data-index="' + k + '"]').addClass('selected');
        }
      }
    }
  }

  jQuery(document).on('click', wrapSelector + ' ' + listSelector + ' li', function(){

    var idx = parseInt(jQuery(this).attr('data-index'), 10);
    var default_max = getMax();

    // A "closed" range already exists (two distinct endpoints picked) —
    // any further click starts a brand-new single-swatch selection instead
    // of forever extending from the original anchor.
    if(state.anchor_index !== null && state.last_index !== null && state.anchor_index !== state.last_index){
      state.anchor_index = idx;
      state.last_index   = idx;
      render(idx - 1, idx, 'false', state.filter_title, true);
      return;
    }

    // Clicking the same already-single-selected swatch again clears it.
    if(state.anchor_index !== null && state.anchor_index === state.last_index && idx === state.anchor_index){
      state.anchor_index = null;
      state.last_index   = null;
      render(0, default_max, 'false', state.filter_title, false);
      return;
    }

    if(state.anchor_index === null){
      state.anchor_index = idx;
      state.last_index   = idx;
    }else{
      state.last_index = idx;
    }

    var lo = Math.min(state.anchor_index, state.last_index);
    var hi = Math.max(state.anchor_index, state.last_index);

    render(lo - 1, hi, 'false', state.filter_title, true);
  });

  window[filterKey + '_slider_render'] = render;

  return render;
}
/*** Color Range Slider Filter End ***/

/*** Instantiate one per filter ***/
// Note: max-variable names below are taken directly from your codebase
// (resetFilters(), getSelectedRangeFilterValues() calls) — they don't all
// follow the "default_max_<filterKey>" pattern, so they're spelled out explicitly.
var color_slider_render        = createSwatchFilter('color',        'default_max_color');
var clarity_slider_render      = createSwatchFilter('clarity',      'default_max_clarity');
var intensity_slider_render      = createSwatchFilter('intensity',      'default_max_intensity');
var polish_slider_render       = createSwatchFilter('polish',       'default_max_polish');
var symmetry_slider_render     = createSwatchFilter('symmetry',     'default_max_symm');     // NOT default_max_symmetry
var cut_slider_render          = createSwatchFilter('cut',          'default_max_cut');
var fluorescence_slider_render = createSwatchFilter('fluorescence', 'default_max_flour');     // NOT default_max_fluorescence
/*** End ***/

/*** Diamond Carat Filter Start ***/
function getCaratCalibArray(minDiamondCarat,maxDiamondCarat) {
  var carat = [];
  for (i = parseFloat(minDiamondCarat); i < parseFloat(maxDiamondCarat); i = i + 0.01) {
  	var dec = i.toFixed(2);
  	carat.push(dec);
  }    
  carat.push(maxDiamondCarat);
  return carat;
}
  
var caratFilterFirstLoad = true;
function carat_slider_render(min_carat, max_carat, option, filterLabel) { 
    var carat = getCaratCalibArray(default_carat_min,default_carat_max);
  
    var minCarat = getClosestNum(min_carat, carat);
    var maxCarat = getClosestNum(max_carat, carat);   
    var carat_min = get_index(minCarat, carat);	
    var carat_max = get_index(maxCarat, carat);      
  
    var isSelected = false;       
    //session carat filter selected         
     if(parseFloat(min_carat) != default_carat_min || parseFloat(max_carat) != default_carat_max){
       isSelected = true;
     }            
    var caratFilterUnit = "ct.";
    var filterValues = filterLabel+': '+min_carat + ' '+caratFilterUnit+' - '+max_carat + ' '+caratFilterUnit;
       
     setSelectedFilter(filterValues,"carat_slider_render('"+default_carat_min+"', '"+default_carat_max+"','true','"+filterLabel+"')",isSelected,'carat');
     //end
  
	jQuery("#tps_carat_slider").slider({      
		range: true,
		min: 0,
		max: carat.length - 1,
		values: [carat_min, carat_max],
        step: 1,
		slide: function(event, ui) {    
            emptyResultDiv();          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
          
			$("#carat_from").val(carat[parseInt(ui.values[0])]+' '+caratFilterUnit);
            $('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
            $('#carat_to').val(carat[parseInt(ui.values[1])]+' '+caratFilterUnit);
            $('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);            
		},
		change: function(event, ui) {   
            var resetFlag = checkResetFlag();
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}			

			if (option) {                  				
        //applied filter code start here   
          var isSelected = false;                        
          if(carat[parseInt(ui.values[0])] != parseFloat(default_carat_min) || carat[parseInt(ui.values[1])] != parseFloat(default_carat_max)){
                isSelected = true;
          }    
                            
          var caratLeft = carat[parseInt(ui.values[0])];
          var caratRight = carat[parseInt(ui.values[1])];

          $("#carat_from").val(caratLeft+' '+caratFilterUnit);
          $('#carat_left_hidden').val(caratLeft);
          $('#carat_to').val(caratRight+' '+caratFilterUnit);
          $('#carat_right_hidden').val(caratRight);                       
                      
          var filterValues = filterLabel+': '+caratLeft+ ' '+caratFilterUnit+' - '+caratRight+ ' '+caratFilterUnit;
            
          setSelectedFilter(filterValues,"carat_slider_render('"+default_carat_min+"', '"+default_carat_max+"','true','"+filterLabel+"')",isSelected,'carat');
          //end 

          updateSessionFilters(session_variable+'-filters',filterLabel, caratLeft+","+caratRight);

          // skip the API call only on the very first init-triggered change                  
          if (event == null) {
              return;
          }

          if(resetFlag != 'true'){
            jQuery('#page_no').val(1);
            jQuery('#pagination').val('');   
            graphqlDataCall();                       
          }
			}
           
		}

	});
    
    min_carat = min_carat ? min_carat : default_carat_min;
    $("#carat_from").val(min_carat+' '+caratFilterUnit);
    $("#carat_to").val(max_carat+' '+caratFilterUnit);
    $('#carat_left_hidden').val(min_carat);
    $('#carat_right_hidden').val(max_carat);    
}

function replace_carat_from(ele,min_carat,filterLabel) {   
	var settingSelected = $("#setting").val();
  var caratFilterUnit = "ct.";
  var carat_min_value = parseFloat($('#carat_from').val());
	var carat_max_value = parseFloat($('#carat_to').val());

	if ($('#carat_from').val() == '') {		
    $('#carat_from').val((parseFloat(default_carat_min).toFixed(2))+" "+caratFilterUnit);
		carat_slider_render(default_carat_min, carat_max_value, true);
		return false;
	} else {
		var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
		var carat_value = parseFloat($('#carat_from').val()).toFixed(2);
	}  
 
	if (isNaN(carat_min_value) != false) {
        value = parseFloat(default_carat_min).toFixed(2); 
        alert(translations.titlePleaseEnterValueInNumber);        
		$('#carat_from').val(value +' '+caratFilterUnit);
	} else if (carat_min_value > carat_max_value) {	
        alert(translations.titleIncorrectCaratRange);
		$('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2)+' '+caratFilterUnit);
		return false;
	} else if (carat_value < default_carat_min) {	
        alert(translations.titleIncorrectCaratRange);
		$('#carat_from').val((parseFloat(default_carat_min).toFixed(2))+" "+caratFilterUnit);
		carat_slider_render(default_carat_min, carat_max_value, true);
		return false;
	} else if (settingSelected == 1 && (hidden_carat_value > carat_value)) { 
    alert(translations.titleCanMatchWithDiamond+' '+carat_value);      	
		$('#carat_from').val(hidden_carat_value+" "+caratFilterUnit);
		return false;
	}
	$('#carat_left_hidden').val(carat_min_value);
	$('#carat_right_hidden').val(carat_max_value);
    
	carat_slider_render(carat_min_value, carat_max_value, true, filterLabel);
}

function replace_carat_to(ele, max_carat, filterLabel) {
    var settingSelected = $("#setting").val();
    var caratFilterUnit = "ct.";

    var carat_max_value = parseFloat($('#carat_to').val());
    var carat_min_value = parseFloat($('#carat_from').val());

    // If Carat To is blank, reset it to the default maximum carat
    if ($('#carat_to').val().trim() == '') {
        var defaultMaxValue = parseFloat(default_carat_max).toFixed(2);
        $('#carat_to').val(defaultMaxValue + " " + caratFilterUnit);
        // Update hidden value with the default max
        $('#carat_right_hidden').val(default_carat_max);
        carat_slider_render(carat_min_value, default_carat_max, true, filterLabel);
        return false;
    } else {
        var hidden_carat_value = parseFloat($('#carat_right_hidden').val()).toFixed(2);
        var carat_value = parseFloat($('#carat_to').val()).toFixed(2);
    }

    // Invalid number
    if (isNaN(carat_max_value)) {
        var value = parseFloat(default_carat_max).toFixed(2);
        alert(translations.titlePleaseEnterValueInNumber);
        $('#carat_to').val(value + " " + caratFilterUnit);
        $('#carat_right_hidden').val(default_carat_max);
        carat_slider_render(carat_min_value, default_carat_max, true, filterLabel);
        return false;
    // Maximum value exceeded
    } else if (carat_max_value > parseFloat(default_carat_max)) {
        alert(translations.titleIncorrectCaratRange);
        $('#carat_to').val(parseFloat(default_carat_max).toFixed(2) + " " + caratFilterUnit);
        $('#carat_right_hidden').val(default_carat_max);
        return false;
    // Minimum is greater than maximum
    } else if (carat_min_value > carat_max_value) {
        alert(translations.titleIncorrectCaratRange);
        $('#carat_to').val(hidden_carat_value + " " + caratFilterUnit);
        return false;
    // Setting restriction
    } else if (settingSelected == 1 && (hidden_carat_value < carat_value)) {
        alert(translations.titleCanMatchWithDiamond + ' ' + carat_value);
        $('#carat_to').val(hidden_carat_value + " " + caratFilterUnit);
        return false;
    }

    $('#carat_right_hidden').val(carat_max_value);
    $('#carat_left_hidden').val(carat_min_value);

    carat_slider_render(carat_min_value, carat_max_value, true, filterLabel);
}

/*** Carat Spinner Arrows (Up/Down) ***/
var caratStep = 0.01; // step size for the arrows — bump to 0.1 if you want coarser increments

function adjustCarat(btn, type, direction, filterLabel) {
  if ($(btn).hasClass('disabled')) return false;

  var caratFilterUnit = "ct.";
  var inputId  = (type === 'min') ? '#carat_from' : '#carat_to';
  var hiddenId = (type === 'min') ? '#carat_left_hidden' : '#carat_right_hidden';

  var currentVal = parseFloat($(hiddenId).val());
  if (isNaN(currentVal)) {
    currentVal = (type === 'min') ? parseFloat(default_carat_min) : parseFloat(default_carat_max);
  }

  var newVal = (direction === 'up') ? currentVal + caratStep : currentVal - caratStep;
  newVal = parseFloat(newVal.toFixed(2));

  // write it the same way the slider does, then run it through your existing
  // validation functions — same alerts/clamping you already have for typing in the box
  $(inputId).val(newVal + ' ' + caratFilterUnit);

  if (type === 'min') {
    replace_carat_from(null, newVal, filterLabel);
  } else {
    replace_carat_to(null, newVal, filterLabel);
  }

  refreshCaratStepperButtons();
}

function refreshCaratStepperButtons() {
  var minVal = parseFloat($('#carat_left_hidden').val());
  var maxVal = parseFloat($('#carat_right_hidden').val());

  $('.tps-carat-box-min .tps-carat-step-down').toggleClass('disabled', minVal <= parseFloat(default_carat_min));
  $('.tps-carat-box-min .tps-carat-step-up').toggleClass('disabled', minVal >= maxVal);

  $('.tps-carat-box-max .tps-carat-step-up').toggleClass('disabled', maxVal >= parseFloat(default_carat_max));
  $('.tps-carat-box-max .tps-carat-step-down').toggleClass('disabled', maxVal <= minVal);
}
/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter Start ***/
var priceFilterFirstLoad = true; // blocks only the very first render call from hitting the API

function getPriceCalibArray(minDiamondPrice, maxDiamondPrice) {
  var price = [];

  for (var i = parseInt(minDiamondPrice); i < 2500; i = i + 1) { price.push(i); }
  for (var i = 2500; i < 5000; i = i + 10) { price.push(i); }
  for (var i = 5000; i < 6000; i = i + 15) { price.push(i); }
  for (var i = 6000; i < 7000; i = i + 20) { price.push(i); }
  for (var i = 7000; i < 8000; i = i + 25) { price.push(i); }
  for (var i = 8000; i < 9000; i = i + 30) { price.push(i); }
  for (var i = 9000; i < 10000; i = i + 35) { price.push(i); }
  for (var i = 10000; i < 15000; i = i + 40) { price.push(i); }
  for (var i = 15000; i < 25000; i = i + 50) { price.push(i); }
  for (var i = 25000; i < 50000; i = i + 100) { price.push(i); }
  for (var i = 50000; i < 80000; i = i + 200) { price.push(i); }
  for (var i = 80000; i < 100000; i = i + 500) { price.push(i); }

  price.push(parseInt(maxDiamondPrice));
  return price;
}

function get_priceindex(price_min, price_max, value) {
  var price = getPriceCalibArray(price_min, price_max);
  var pos = 0;
  for (i = 0; i < price.length; i++) {
    if (price[i] == value) {
      pos = i;
      break;
    }
  }
  return pos;
}

// Displayed values are currency-formatted (e.g. "$1,234"), so plain parseFloat()
// on them fails since the string starts with a non-digit ($). Strip everything
// except digits and a dot before parsing.
function parsePriceInput(val) {
  if (val === null || val === undefined) return NaN;
  var cleaned = String(val).replace(/[^0-9.]/g, '');
  return parseFloat(cleaned);
}

function applyPriceFilterChange(minPrice, maxPrice, filterLabel) {
  var resetFlag = checkResetFlag();
  emptyResultDiv();

  var isSelected = false;
  if (minPrice != default_price_min || maxPrice != default_price_max) {
    isSelected = true;
  }

  var filterValues = filterLabel + ': ' + Shopify.formatMoney(minPrice * 100, theme.moneyFormat) + ' - ' + Shopify.formatMoney(maxPrice * 100, theme.moneyFormat);
  setSelectedFilter(filterValues, "price_slider_render('" + default_price_min + "', '" + default_price_max + "','true','" + filterLabel + "')", isSelected, 'budget');

  updateSessionFilters(session_variable + '-filters', filterLabel, minPrice + "," + maxPrice);

  if (resetFlag != 'true') {
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');
    graphqlDataCall();
  }
}

// Used for: page load (paints values only) AND the "remove filter" chip link
// (which calls this with option='true' to reset + refetch).
function price_slider_render(min_price, max_price, option, filterLabel) {
  var start_num = parseInt(min_price);
  var end_num = parseInt(max_price);

  jQuery('#budget_left_hidden').val(start_num.toFixed(0));
  jQuery('#budget_right_hidden').val(end_num.toFixed(0));
  jQuery('#price_from').val(Shopify.formatMoney(start_num * 100, theme.moneyFormat));
  jQuery('#price_to').val(Shopify.formatMoney(end_num * 100, theme.moneyFormat));

  var isSelected = false;
  if (min_price != default_price_min || max_price != default_price_max) {
    isSelected = true;
  }
  var filterValues = filterLabel + ': ' + Shopify.formatMoney(min_price * 100, theme.moneyFormat) + ' - ' + Shopify.formatMoney(max_price * 100, theme.moneyFormat);
  setSelectedFilter(filterValues, "price_slider_render('" + default_price_min + "', '" + default_price_max + "','true','" + filterLabel + "')", isSelected, 'budget');

  // NEW: make sure the spinner buttons reflect the correct disabled/enabled
  // state as soon as values are painted — including on the very first page
  // load, not just after a user interaction.
  refreshPriceStepperButtons();

  if (option) {
    // first call ever (page load) — skip the API call, just paint values
    if (priceFilterFirstLoad) {
      priceFilterFirstLoad = false;
      return;
    }
    // remove-filter chip or explicit reset — genuine action, refetch
    applyPriceFilterChange(start_num, end_num, filterLabel);
  }
}

function replace_price_from(ele, min_price, filterLabel) {
  var price_min_value = parsePriceInput($('#price_from').val());
  var price_max_value = parsePriceInput($('#price_to').val());
  var hidden_price_value = parseFloat($('#budget_left_hidden').val());

  if ($('#price_from').val() == '') {    
    $('#price_from').val(Shopify.formatMoney(default_price_min * 100, theme.moneyFormat));
    price_slider_render(default_price_min, price_max_value, false, filterLabel);
    return false;
  }

  if (isNaN(price_min_value)) {
    alert(translations.titlePleaseEnterValueInNumber);
    $('#price_from').val(Shopify.formatMoney(hidden_price_value * 100, theme.moneyFormat));
    return false;
  } else if (price_min_value > price_max_value) {
    alert(translations.titleIncorrectPriceRange);
    $('#price_from').val(Shopify.formatMoney(hidden_price_value * 100, theme.moneyFormat));
    return false;
  } else if (price_min_value < parseFloat(default_price_min)) {
    alert(translations.titleIncorrectPriceRange);
    $('#price_from').val(Shopify.formatMoney(default_price_min * 100, theme.moneyFormat));
    price_slider_render(default_price_min, price_max_value, false, filterLabel);
    return false;
  }

  $('#budget_left_hidden').val(price_min_value);
  $('#budget_right_hidden').val(price_max_value);

  // paint values only (option=false) — applyPriceFilterChange is called
  // directly below, exactly once, so this never double-fires the API call
  price_slider_render(price_min_value, price_max_value, false, filterLabel);
  applyPriceFilterChange(price_min_value, price_max_value, filterLabel);
}

function replace_price_to(ele, max_price, filterLabel) {
  var price_max_value = parsePriceInput($('#price_to').val());
  var price_min_value = parsePriceInput($('#price_from').val());
  var hidden_price_value = parseFloat($('#budget_right_hidden').val());

  if ($('#price_to').val() == '') {    
    $('#price_to').val(Shopify.formatMoney(default_price_max * 100, theme.moneyFormat));
    price_slider_render(price_min_value, default_price_max, false, filterLabel);
    return false;
  }
  
  if (isNaN(price_max_value)) {
    alert(translations.titlePleaseEnterValueInNumber);
    $('#price_to').val(Shopify.formatMoney(hidden_price_value * 100, theme.moneyFormat));
    return false;
  } else if (price_min_value > price_max_value) {
    alert(translations.titleIncorrectPriceRange);
    $('#price_to').val(Shopify.formatMoney(hidden_price_value * 100, theme.moneyFormat));
    return false;
  } else if (price_max_value > parseFloat(default_price_max)) {
    alert(translations.titleIncorrectPriceRange);
    $('#price_to').val(Shopify.formatMoney(default_price_max * 100, theme.moneyFormat));
    price_slider_render(price_min_value, default_price_max, false, filterLabel);
    return false;
  }

  $('#budget_right_hidden').val(price_max_value);
  $('#budget_left_hidden').val(price_min_value);

  price_slider_render(price_min_value, price_max_value, false, filterLabel);
  applyPriceFilterChange(price_min_value, price_max_value, filterLabel);
}

/*** Price Spinner Arrows (Up/Down) ***/
// Price steps aren't fixed — they widen at higher price bands (see getPriceCalibArray),
// so arrows step through the calibration array rather than a flat increment.
//
// NEW: guarded against the boundary no-op case. If the user is already at
// default_price_min and clicks the min "down" arrow (or already at
// default_price_max and clicks the max "up" arrow), the clamped index maps
// back to the SAME value. Previously that still fell through to
// replace_price_from/replace_price_to -> applyPriceFilterChange ->
// graphqlDataCall(), firing a pointless API call. Now we detect "no real
// change" and just re-sync the button disabled states instead.
function adjustPrice(btn, type, direction, filterLabel) {
  if ($(btn).hasClass('disabled')) return false;

  var priceArray = getPriceCalibArray(default_price_min, default_price_max);
  var inputId  = (type === 'min') ? '#price_from' : '#price_to';
  var hiddenId = (type === 'min') ? '#budget_left_hidden' : '#budget_right_hidden';

  var currentVal = parseFloat($(hiddenId).val());
  if (isNaN(currentVal)) {
    currentVal = (type === 'min') ? parseFloat(default_price_min) : parseFloat(default_price_max);
  }

  var closest = getClosestNum(currentVal, priceArray);
  var idx = get_priceindex(default_price_min, default_price_max, closest);

  var newIdx = (direction === 'up') ? idx + 1 : idx - 1;
  newIdx = Math.max(0, Math.min(newIdx, priceArray.length - 1));
  var newVal = priceArray[newIdx];

  // Already at the boundary in this direction — nothing actually changes,
  // so validate/no-op instead of touching the inputs or hitting the API.
  if (newVal == currentVal) {
    refreshPriceStepperButtons();
    alert(translations.titleIncorrectPriceRange);
    return false;
  }

  $(inputId).val(Shopify.formatMoney(newVal * 100, theme.moneyFormat));

  if (type === 'min') {
    replace_price_from(null, newVal, filterLabel);
  } else {
    replace_price_to(null, newVal, filterLabel);
  }

  refreshPriceStepperButtons();
}

function refreshPriceStepperButtons() {
  var minVal = parseFloat($('#budget_left_hidden').val());
  var maxVal = parseFloat($('#budget_right_hidden').val());

  $('.tps-price-box-min .tps-price-step-down').toggleClass('disabled', minVal <= parseFloat(default_price_min));
  $('.tps-price-box-min .tps-price-step-up').toggleClass('disabled', minVal >= maxVal);

  $('.tps-price-box-max .tps-price-step-up').toggleClass('disabled', maxVal >= parseFloat(default_price_max));
  $('.tps-price-box-max .tps-price-step-down').toggleClass('disabled', maxVal <= minVal);
}

/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
    return false;
  }
});

$("#price_from").keypress(function(e) {
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
    return false;
  }
});
/*** Price Validation End ***/

/*** Diamond Price Filter End ***/
function getPriceWithoutSymbolAndCommas(input_price) {
  var price = input_price;
  if(input_price.indexOf("£") >= 0){
    price = input_price.replace('£', '');
    price = price.replace(/[^\d\.]/g, '');    
  }else if(input_price.indexOf("$") >= 0){
    price = input_price.replace('$', '');
    price = price.replace('.00', '');
    price = price.replace(/,/g, ''); 
  }else if(input_price.indexOf("€") >= 0){
    price = input_price.replace('€', '');    
    price = price.replace(',00', ''); 
    price = price.replace(/\./g, '');
  }
  
  return price;
}
/*** Diamond Price Filter End ***/

/*** Table Filter Start ***/

var tableFilterFirstLoad = true; // blocks only the very first render call from hitting the API

function applyTableFilterChange(minTable, maxTable, filterLabel) {
  var resetFlag = checkResetFlag();
  emptyResultDiv();

  var isSelected = false;
  if (minTable != parseInt(default_table_min) || maxTable != parseInt(default_table_max)) {
    isSelected = true;
  }

  var filterValues = (translations.titleTable ? translations.titleTable.replace(' %', '') : filterLabel) + ': ' + minTable + ' % - ' + maxTable + ' %';
  setSelectedFilter(filterValues, "table_slider_render('" + default_table_min + "', '" + default_table_max + "','true','" + filterLabel + "')", isSelected, 'table');

  updateSessionFilters(session_variable + '-filters', filterLabel, minTable + "," + maxTable);

  if (resetFlag != 'true') {
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');
    graphqlDataCall();
  }
}

// Used for: page load (paints values only) AND the "remove filter" chip link
// (which calls this with option='true' to reset + refetch).
function table_slider_render(min_table, max_table, option, filterLabel) {
  var start_limit = parseFloat(min_table);
  var end_limit = parseFloat(max_table);

  $("#table_from").val(start_limit);
  $("#table_to").val(end_limit);

  $('#table_left_hidden').val(min_table);
  $('#table_right_hidden').val(max_table);

  var isSelected = false;  
  if (min_table != parseInt(default_table_min) || max_table != parseInt(default_table_max)) {
    isSelected = true;
  }
  var filterValues = filterLabel + ': ' + min_table + ' % - ' + max_table + ' %';
  setSelectedFilter(filterValues, "table_slider_render('" + parseInt(default_table_min) + "', '" + parseInt(default_table_max) + "','true','" + filterLabel + "')", isSelected, 'table');

  if (option) {
    // first call ever (page load) — skip the API call, just paint values
    if (tableFilterFirstLoad) {
      tableFilterFirstLoad = false;
      return;
    }
    // every subsequent truthy call (remove-filter chip, or any explicit reset)
    // is a genuine user action — refetch results
    applyTableFilterChange(start_limit, end_limit, filterLabel);
  }
}

function replace_table_from(ele, min_table, filterLabel) {
  var table_min_value = parseFloat($('#table_from').val());
  var table_max_value = parseFloat($('#table_to').val());

  if ($('#table_from').val() == '') {
    var value = parseFloat(default_table_min);    
    $('#table_from').val(value);    
    table_slider_render(default_table_min, table_max_value, false, filterLabel);
    return false;
  } else {
    var table_value = parseFloat($('#table_from').val());
    var hidden_table_value = $('#table_left_hidden').val();
  }

  if (isNaN(table_min_value) != false) {
    var value = parseFloat(default_table_min);
    alert(translations.titlePleaseEnterValueInNumber);
    $('#table_from').val(value);
    return false;
  } else if (table_min_value > table_max_value) {
    alert(translations.titleIncorrectTableRange);
    var min_value = parseFloat($('#table_left_hidden').val());
    $('#table_from').val((min_value.toFixed(2)));
    return false;
  } else if (table_value < default_table_min) {
    alert(translations.titleIncorrectTableRange);
    $('#table_from').val(default_table_min);
    table_slider_render(default_table_min, table_max_value, false, filterLabel);
    return false;
  }

  $('#table_left_hidden').val(table_min_value);
  $('#table_right_hidden').val(table_max_value);

  // paint values only (option=false) — applyTableFilterChange is called
  // directly below, exactly once, so this never double-fires the API call
  table_slider_render(table_min_value, table_max_value, false, filterLabel);
  applyTableFilterChange(table_min_value, table_max_value, filterLabel);
}

function replace_table_to(ele, max_table, filterLabel) {
  var table_min_value = parseFloat($('#table_from').val());
  var table_max_value = parseFloat(jQuery('#table_to').val());

  if (jQuery('#table_to').val() == '') {    
    $('#table_to').val(default_table_max);
    table_slider_render(table_min_value, default_table_max, false, filterLabel);
    return false;
  } else {
    var table_value = parseFloat(jQuery('#table_to').val());
    var hidden_table_value = $('#table_right_hidden').val();
  }  

  if (isNaN(table_max_value) != false) {
    var max_value = default_table_max;
    alert(translations.titlePleaseEnterValueInNumber);
    jQuery('#table_to').val(max_value);
    return false;
  } else if (table_min_value > table_max_value) {
    alert(translations.titleIncorrectTableRange);
    var max_value = parseFloat(jQuery('#table_right_hidden').val());
    jQuery('#table_to').val((max_value.toFixed(2)));
    return false;
  } else if (table_max_value > default_table_max) {
    alert(translations.titleIncorrectTableRange);
    $('#table_to').val(default_table_max);
    table_slider_render(table_min_value, default_table_max, false, filterLabel);
    return false;
  }

  $('#table_right_hidden').val(table_max_value);
  $('#table_left_hidden').val(table_min_value);

  table_slider_render(table_min_value, table_max_value, false, filterLabel);
  applyTableFilterChange(table_min_value, table_max_value, filterLabel);
}

/*** Table Spinner Arrows (Up/Down) ***/
var tableStep = 0.10;

function adjustTable(btn, type, direction, filterLabel) {
  if ($(btn).hasClass('disabled')) return false;

  var inputId  = (type === 'min') ? '#table_from' : '#table_to';
  var hiddenId = (type === 'min') ? '#table_left_hidden' : '#table_right_hidden';

  var currentVal = parseFloat($(hiddenId).val());
  if (isNaN(currentVal)) {
    currentVal = (type === 'min') ? parseFloat(default_table_min) : parseFloat(default_table_max);
  }

  var newVal = (direction === 'up') ? currentVal + tableStep : currentVal - tableStep;
  newVal = parseFloat(newVal.toFixed(2));

  $(inputId).val(newVal);

  if (type === 'min') {
    replace_table_from(null, newVal, filterLabel);
  } else {
    replace_table_to(null, newVal, filterLabel);
  }

  refreshTableStepperButtons();
}

function refreshTableStepperButtons() {
  var minVal = parseFloat($('#table_left_hidden').val());
  var maxVal = parseFloat($('#table_right_hidden').val());

  $('.tps-table-spinner-box.tps-table-box-min .tps-spinner-down').toggleClass('disabled', minVal <= parseFloat(default_table_min));
  $('.tps-table-spinner-box.tps-table-box-min .tps-spinner-up').toggleClass('disabled', minVal >= maxVal);

  $('.tps-table-spinner-box.tps-table-box-max .tps-spinner-up').toggleClass('disabled', maxVal >= parseFloat(default_table_max));
  $('.tps-table-spinner-box.tps-table-box-max .tps-spinner-down').toggleClass('disabled', maxVal <= minVal);
}
/*** Table Filter End ***/

/*** Depth Filter Start ***/

var depthFilterFirstLoad = true; // blocks only the very first render call from hitting the API

function applyDepthFilterChange(minDepth, maxDepth, filterLabel) {
  var resetFlag = checkResetFlag();
  emptyResultDiv();

  var isSelected = false;
  if (minDepth != parseInt(default_depth_min) || maxDepth != parseInt(default_depth_max)) {
    isSelected = true;
  }

  var filterValues = (translations.titleDepth ? translations.titleDepth.replace(' %', '') : filterLabel) + ': ' + minDepth + ' % - ' + maxDepth + ' %';
  setSelectedFilter(filterValues, "depth_slider_render('" + default_depth_min + "', '" + default_depth_max + "','true','" + filterLabel + "')", isSelected, 'depth');

  updateSessionFilters(session_variable + '-filters', filterLabel, minDepth + "," + maxDepth);

  if (resetFlag != 'true') {
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');
    graphqlDataCall();
  }
}

function depth_slider_render(min_depth, max_depth, option, filterLabel) {
  var start_limit = parseFloat(min_depth);
  var end_limit = parseFloat(max_depth);

  $("#depth_from").val(start_limit);
  $("#depth_to").val(end_limit);

  $('#depth_left_hidden').val(min_depth);
  $('#depth_right_hidden').val(max_depth);

  var isSelected = false;
  if (min_depth != parseInt(default_depth_min) || max_depth != parseInt(default_depth_max)) {
    isSelected = true;
  }
  var filterValues = filterLabel + ': ' + min_depth + ' % - ' + max_depth + ' %';
  setSelectedFilter(filterValues, "depth_slider_render('" + parseInt(default_depth_min) + "', '" + parseInt(default_depth_max) + "','true','" + filterLabel + "')", isSelected, 'depth');

  if (option) {
    if (depthFilterFirstLoad) {
      depthFilterFirstLoad = false;
      return;
    }
    applyDepthFilterChange(start_limit, end_limit, filterLabel);
  }
}

function replace_depth_from(ele, depth_min, filterLabel) {
  var depth_min_value = parseFloat($('#depth_from').val());
  var depth_max_value = parseFloat($('#depth_to').val());

  if ($('#depth_from').val() == '') {   
    $('#depth_from').val(default_depth_min);
    depth_slider_render(default_depth_min, depth_max_value, false, filterLabel);
    return false;
  } else {
    var depth_value = parseFloat($('#depth_from').val());
    var hidden_depth_value = $('#depth_left_hidden').val();
  } 

  if (isNaN(depth_min_value) != false) {
    var value = parseFloat(default_depth_min);
    alert(translations.titlePleaseEnterValueInNumber);
    $('#depth_from').val(value);
    return false;
  } else if (depth_min_value > depth_max_value) {
    alert(translations.titleIncorrectDepthRange);
    var min_value = parseFloat($('#depth_left_hidden').val());
    $('#depth_from').val(min_value);
    return false;
  } else if (depth_value < default_depth_min) {
    alert(translations.titleIncorrectDepthRange);
    $('#depth_from').val(default_depth_min);
    depth_slider_render(default_depth_min, depth_max_value, false, filterLabel);
    return false;
  }

  $('#depth_left_hidden').val(depth_min_value);
  $('#depth_right_hidden').val(depth_max_value);

  // paint values only (option=false) — we call applyDepthFilterChange directly
  // below, exactly once, so this never double-fires the API call
  depth_slider_render(depth_min_value, depth_max_value, false, filterLabel);
  applyDepthFilterChange(depth_min_value, depth_max_value, filterLabel);
}

function replace_depth_to(ele, depth_max, filterLabel) {
  var depth_min_value = parseFloat($('#depth_from').val());
  var depth_max_value = parseFloat(jQuery('#depth_to').val());

  if (jQuery('#depth_to').val() == '') {    
    $('#depth_to').val(default_depth_max);
    depth_slider_render(depth_min_value, default_depth_max, false, filterLabel);
    return false;
  } else {
    var depth_value = parseFloat(jQuery('#depth_to').val());
    var hidden_depth_value = $('#depth_right_hidden').val();
  }  

  if (isNaN(depth_max_value) != false) {
    var max_value = default_depth_max;
    alert(translations.titlePleaseEnterValueInNumber);
    jQuery('#depth_to').val(max_value);
    return false;
  } else if (depth_min_value > depth_max_value) {
    alert(translations.titleIncorrectDepthRange);
    var max_value = parseFloat(jQuery('#depth_right_hidden').val());
    jQuery('#depth_to').val(max_value);
    return false;
  } else if (depth_max_value > default_depth_max) {
    alert(translations.titleIncorrectDepthRange);
    $('#depth_to').val(default_depth_max);
    depth_slider_render(depth_min_value, default_depth_max, false, filterLabel);
    return false;
  }

  $('#depth_right_hidden').val(depth_max_value);
  $('#depth_left_hidden').val(depth_min_value);

  depth_slider_render(depth_min_value, depth_max_value, false, filterLabel);
  applyDepthFilterChange(depth_min_value, depth_max_value, filterLabel);
}

/*** Depth Spinner Arrows (Up/Down) ***/
var depthStep = 0.10;

function adjustDepth(btn, type, direction, filterLabel) {
  if ($(btn).hasClass('disabled')) return false;

  var inputId  = (type === 'min') ? '#depth_from' : '#depth_to';
  var hiddenId = (type === 'min') ? '#depth_left_hidden' : '#depth_right_hidden';

  var currentVal = parseFloat($(hiddenId).val());
  if (isNaN(currentVal)) {
    currentVal = (type === 'min') ? parseFloat(default_depth_min) : parseFloat(default_depth_max);
  }

  var newVal = (direction === 'up') ? currentVal + depthStep : currentVal - depthStep;
  newVal = parseFloat(newVal.toFixed(2));

  $(inputId).val(newVal);

  if (type === 'min') {
    replace_depth_from(null, newVal, filterLabel);
  } else {
    replace_depth_to(null, newVal, filterLabel);
  }

  refreshDepthStepperButtons();
}

function refreshDepthStepperButtons() {
  var minVal = parseFloat($('#depth_left_hidden').val());
  var maxVal = parseFloat($('#depth_right_hidden').val());

  $('.tps-depth-spinner-box.tps-depth-box-min .tps-spinner-down').toggleClass('disabled', minVal <= parseFloat(default_depth_min));
  $('.tps-depth-spinner-box.tps-depth-box-min .tps-spinner-up').toggleClass('disabled', minVal >= maxVal);

  $('.tps-depth-spinner-box.tps-depth-box-max .tps-spinner-up').toggleClass('disabled', maxVal >= parseFloat(default_depth_max));
  $('.tps-depth-spinner-box.tps-depth-box-max .tps-spinner-down').toggleClass('disabled', maxVal <= minVal);
}
/*** Depth Filter End ***/

/*** Ratio Filter Start ***/
var ratioFilterFirstLoad = true; // blocks only the very first render call from hitting the API

function applyRatioFilterChange(minRatio, maxRatio, filterLabel) {
  var resetFlag = checkResetFlag();
  emptyResultDiv();

  var isSelected = false;
  if (parseFloat(minRatio) != parseFloat(default_ratio_min) || parseFloat(maxRatio) != parseFloat(default_ratio_max)) {
    isSelected = true;
  }

  var filterValues = (translations.titleRatio ? translations.titleRatio : filterLabel) + ': ' + minRatio + ' - ' + maxRatio;
  setSelectedFilter(filterValues, "ratio_slider_render('" + default_ratio_min + "', '" + default_ratio_max + "','true','" + filterLabel + "')", isSelected, 'ratio');

  updateSessionFilters(session_variable + '-filters', filterLabel, minRatio + "," + maxRatio);

  if (resetFlag != 'true') {
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');
    graphqlDataCall();
  }
}

// Used for: page load (paints values only) AND the "remove filter" chip link
// (which calls this with option='true' to reset + refetch).
function ratio_slider_render(min_ratio, max_ratio, option, filterLabel) {
  var start_limit = parseFloat(min_ratio);
  var end_limit = parseFloat(max_ratio);

  $("#ratio_from").val(start_limit);
  $("#ratio_to").val(end_limit);

  $('#ratio_left_hidden').val(min_ratio);
  $('#ratio_right_hidden').val(max_ratio);

  var isSelected = false;
  if (parseFloat(min_ratio) != parseFloat(default_ratio_min) || parseFloat(max_ratio) != parseFloat(default_ratio_max)) {
    isSelected = true;
  }
  var filterValues = filterLabel + ': ' + min_ratio + ' - ' + max_ratio;
  setSelectedFilter(filterValues, "ratio_slider_render('" + parseFloat(default_ratio_min) + "', '" + parseFloat(default_ratio_max) + "','true','" + filterLabel + "')", isSelected, 'ratio');

  if (option) {
    // first call ever (page load) — skip the API call, just paint values
    if (ratioFilterFirstLoad) {
      ratioFilterFirstLoad = false;
      return;
    }
    // every subsequent truthy call (remove-filter chip, or any explicit reset)
    // is a genuine user action — refetch results
    applyRatioFilterChange(start_limit, end_limit, filterLabel);
  }
}

function replace_ratio_from(ele, min_ratio, filterLabel) {
  var ratio_min_value = parseFloat($('#ratio_from').val());
  var ratio_max_value = parseFloat($('#ratio_to').val());

  if ($('#ratio_from').val() == '') {    
    $('#ratio_from').val(default_ratio_min);
    ratio_slider_render(default_ratio_min, ratio_max_value, false, filterLabel);
    return false;
  } else {
    var ratio_value = parseFloat($('#ratio_from').val());
    var hidden_ratio_value = $('#ratio_left_hidden').val();
  }  

  if (isNaN(ratio_min_value) != false) {
    var value = parseFloat(default_ratio_min);
    alert(translations.titlePleaseEnterValueInNumber);
    $('#ratio_from').val(value);
    return false;
  } else if (ratio_min_value > ratio_max_value) {
    alert(translations.titleIncorrectRatioRange);
    var min_value = parseFloat($('#ratio_left_hidden').val());
    $('#ratio_from').val(min_value);
    return false;
  } else if (ratio_value < default_ratio_min) {
    alert(translations.titleIncorrectRatioRange);
    $('#ratio_from').val(default_ratio_min);
    ratio_slider_render(default_ratio_min, ratio_max_value, false, filterLabel);
    return false;
  }

  $('#ratio_left_hidden').val(ratio_min_value);
  $('#ratio_right_hidden').val(ratio_max_value);

  // paint values only (option=false) — applyRatioFilterChange is called
  // directly below, exactly once, so this never double-fires the API call
  ratio_slider_render(ratio_min_value, ratio_max_value, false, filterLabel);
  applyRatioFilterChange(ratio_min_value, ratio_max_value, filterLabel);
}

function replace_ratio_to(ele, max_ratio, filterLabel) {
  var ratio_min_value = parseFloat($('#ratio_from').val());
  var ratio_max_value = parseFloat(jQuery('#ratio_to').val());

  if (jQuery('#ratio_to').val() == '') {
    // var max_value = parseFloat(jQuery('#ratio_right_hidden').val());
    // jQuery('#ratio_to').val(max_value);
    $('#ratio_to').val(default_ratio_max);
    ratio_slider_render(ratio_min_value, default_ratio_max, false, filterLabel);
    return false;
  } else {
    var ratio_value = parseFloat(jQuery('#ratio_to').val());
    var hidden_ratio_value = $('#ratio_right_hidden').val();
  }  

  if (isNaN(ratio_max_value) != false) {
    var max_value = default_ratio_max;
    alert(translations.titlePleaseEnterValueInNumber);
    jQuery('#ratio_to').val(max_value);
    return false;
  } else if (ratio_min_value > ratio_max_value) {
    alert(translations.titleIncorrectRatioRange);
    var max_value = parseFloat(jQuery('#ratio_right_hidden').val());
    jQuery('#ratio_to').val(max_value);
    return false;
  } else if (ratio_max_value > default_ratio_max) {
    alert(translations.titleIncorrectRatioRange);
    $('#ratio_to').val(default_ratio_max);
    ratio_slider_render(ratio_min_value, default_ratio_max, false, filterLabel);
    return false;
  }

  $('#ratio_right_hidden').val(ratio_max_value);
  $('#ratio_left_hidden').val(ratio_min_value);

  ratio_slider_render(ratio_min_value, ratio_max_value, false, filterLabel);
  applyRatioFilterChange(ratio_min_value, ratio_max_value, filterLabel);
}

/*** Ratio Spinner Arrows (Up/Down) ***/
var ratioStep = 0.01;

function adjustRatio(btn, type, direction, filterLabel) {
  if ($(btn).hasClass('disabled')) {
      alert(translations.titleIncorrectRatioRange);
      return false;
  }

  var inputId  = (type === 'min') ? '#ratio_from' : '#ratio_to';
  var hiddenId = (type === 'min') ? '#ratio_left_hidden' : '#ratio_right_hidden';

  var currentVal = parseFloat($(hiddenId).val());
  if (isNaN(currentVal)) {
    currentVal = (type === 'min') ? parseFloat(default_ratio_min) : parseFloat(default_ratio_max);
  }

  var newVal = (direction === 'up') ? currentVal + ratioStep : currentVal - ratioStep;
  newVal = parseFloat(newVal.toFixed(2));

  $(inputId).val(newVal.toFixed(2));

  if (type === 'min') {
    replace_ratio_from(null, newVal, filterLabel);
  } else {
    replace_ratio_to(null, newVal, filterLabel);
  }

  refreshRatioStepperButtons();
}

function refreshRatioStepperButtons() {
  var minVal = parseFloat($('#ratio_left_hidden').val());
  var maxVal = parseFloat($('#ratio_right_hidden').val());

  $('.tps-ratio-box-min .tps-spinner-down').toggleClass('disabled', minVal <= parseFloat(default_ratio_min));
  $('.tps-ratio-box-min .tps-spinner-up').toggleClass('disabled', minVal >= maxVal);

  $('.tps-ratio-box-max .tps-spinner-up').toggleClass('disabled', maxVal >= parseFloat(default_ratio_max));
  $('.tps-ratio-box-max .tps-spinner-down').toggleClass('disabled', maxVal <= minVal);
}
/*** Ratio Filter End ***/

/***3X Additionals Function Start*****/ 
// Function to apply filters dynamically
function applyFiltersFromStorage() {
    var session_variable = jQuery("#session_variable").val();
    var storageKey = session_variable + "-filters";

    var savedFilters = localStorage.getItem(storageKey);
    var filtersObj = savedFilters ? JSON.parse(savedFilters) : {};

    var check_variable = '';

    // Restore selected shape filters
    jQuery(".tps-shape-filter-wrapper input:checkbox").each(function() {
        if (jQuery(this).is(':checked')) {
            check_variable = check_variable ? check_variable + "," + jQuery(this).attr('value') : jQuery(this).attr('value');
        }
    });

    // Default to "Round" if no shape is selected
    if (check_variable === '') {
        check_variable = "Round";
    }   
}

// Ensure filters remain applied on page load
$(document).ready(function() {
    applyFiltersFromStorage();
});

/*** Get Slider Range Filter Min, Max Values ***/
function getFilterValues(min_value,max_value,filter) {
  var filterArray = getFilterArray(filter);

  var i=0;
  var selected_values = [];
  $.each(filterArray, function(key,cut){     
    if(store_lang == 'de'){
       if(i == min_value){
        selected_values.push(cut);
      }
      if(i == max_value-1){
        selected_values.push(cut);
      }
    }else{
      if(i == min_value){
        selected_values.push(key);
      }
      if(i == max_value-1){
        selected_values.push(key);
      }
    }
    i++;     
  });
  
  return selected_values;
}
/*** End ***/

/*** Get Selected Slider Range Filter Values ***/
function getSelectedRangeFilterValues(min_value,max_value,filter,default_value) {
  var filterArray = getFilterArray(filter);

  var i = 0;
  var selected_values = '';
  $.each(filterArray, function(key,cut){   
    if(min_value != 0 || max_value != default_value){
      if(i >= min_value && i <= max_value-1){
          if(i == max_value-1){
            selected_values += key;
          }else{
            selected_values += key+',';
          }        
        }
        i++;  
    }       
  });
  
  return selected_values;
}
/*** End ***/

/*** Get Filter Array Values ***/
function getFilterArray(filter) {  
  var filterArray = '';
  if(filter == 'cut'){   
    if(session_variable == 'ringbuilder-lab-white-diamond' || session_variable == 'ringbuilder-lab-color-diamond'){
      filterArray = cut_array_lab; 
    }else{
      filterArray = cut_array;  
    }    
  }else if(filter == 'polish'){
    filterArray = polish_array;  
  }else if(filter == 'symmetry'){
    filterArray = symmetry_array;  
  }else if(filter == 'fluorescence'){
    filterArray = fluorescence_array;  
  }else if(filter == 'clarity'){
    filterArray = clarity_array;  
  }else if(filter == 'color'){
    filterArray = color_array;  
  }else if(filter == 'intensity'){
    filterArray = intensity_array;  
  }
  return filterArray;
}
/*** End ***/

/*** Set Selected Filters For Session Filters After Reloading Page start ***/
function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {  
  
  if (input_value == 'budget') {
    $('.tps-selected-filter-container').find('li[data-input="budget"]').remove();
  }else if (input_value == 'carat') {     
    $('.tps-selected-filter-container').find('li[data-input="carat"]').remove();
  }else if (input_value == 'depth') {
    $('.tps-selected-filter-container').find('li[data-input="depth"]').remove();
  }else if (input_value == 'table') {
    $('.tps-selected-filter-container').find('li[data-input="table"]').remove();
  }else if (input_value == 'cut') {
    $('.tps-selected-filter-container').find('li[data-input="cut"]').remove();
  }else if (input_value == 'polish') {
    $('.tps-selected-filter-container').find('li[data-input="polish"]').remove();
  }else if (input_value == 'symmetry') {
    $('.tps-selected-filter-container').find('li[data-input="symmetry"]').remove();
  }else if (input_value == 'fluorescence') {
    $('.tps-selected-filter-container').find('li[data-input="fluorescence"]').remove();
  }else if (input_value == 'clarity') {
    $('.tps-selected-filter-container').find('li[data-input="clarity"]').remove();
  }else if (input_value == 'color') {
    $('.tps-selected-filter-container').find('li[data-input="color"]').remove();
  }else if (input_value == 'intensity') {
    $('.tps-selected-filter-container').find('li[data-input="intensity"]').remove();
  }else if (input_value == 'ratio') {
    $('.tps-selected-filter-container').find('li[data-input="ratio"]').remove();
  }else if (input_value == 'reportNumber') {  
    $('.tps-selected-filter-container').find('li[data-input="reportNumber"]').remove();
  }
  
  var value = filter_value.split(':');  
  
  if (hasSelectedClass) {
    var html = '';
    var filter_lable = value[1].trim();
    if(input_value != 'budget' && input_value != 'carat' && input_value != 'depth' && input_value != 'table' && input_value != 'cut' && input_value != 'polish' && input_value != 'symmetry' && input_value != 'clarity' && input_value != 'color' && input_value != 'intensity') {
      //filter_lable = filter_lable.replace(/\-/g, ' ');
    }    
    html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps-filter-values">' + filter_lable + '<span class="tps-filter-remove-option"></span></div></li>';
        
    //remove already applied filter start       
    if ($('#' + value[0] + '-container').length > 0) {
        $('#' + value[0] + '-container').append(html);
    } else {
      var filterLabel = value[0].replace(/\-/g, ' ');      
      if(value[0] == 'Ratio'){
        filterLabel = "L/W "+filterLabel;
      }

      var elecontainer = '<ul id="' + value[0] + '-container"><span class="tps-applied-filter-lable">' + filterLabel + ':</span></ul>';
      
      $('.tps-selected-filter-container').append(elecontainer);
      $('#' + value[0] + '-container').append(html);
    }    
  } else {
    $('.tps-selected-filter-container').find('li[data-filter_value="' + filter_value + '"]').remove();
    if ($('input[value="' + input_value + '"]').length > 0) {
      $('input[value="' + input_value + '"]').prop('checked', false);
    }

    if ($('#' + value[0] + '-container li').length == 0) {
      $('#' + value[0] + '-container').remove();
    }
  }
  if ($('.tps-selected-filter-container li').length > 0) {
    $('.tps-selected-filter-wrapper').show();
  } else {
    $('.tps-selected-filter-wrapper').hide();
  }
}
/*** set selected filters for session filters after reloading page end ***/

/*** Empty Diamond Result Div On Filter Click Start ***/
function emptyResultDiv(flag){
  var diamond_active_tab = jQuery('#diamond_active_tab').val();  
    
  jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').removeClass('tps-no-diamonds-found');
  jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').removeClass('tps-no-diamonds-found');

  jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html('');
  jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html(''); 

  diaListViewBulkData = '';
  diaGridViewBulkData = '';
  
  getAllDiamonds();
}
/*** End ***/

/*** Show Listing View Loader Start ***/
function showLoader(active_tab) {      
  jQuery('.tps-diamond-list-listing-loader .tps-diamondlist-result-list-view-loader').css('display','block');
  jQuery('.tps-diamond-grid-listing-loader .tps-diamondlist-result-grid-view-loader').css('display','block');  
}
/*** Show Listing View Loader End ***/

/*** Sort By Dropdown Open Close ***/
function sortByOpen() {
  if(jQuery('.tps-sort-dropdown-menu').css('display') !== 'none'){    
      sortByClose();
  }else {   
      jQuery('.tps-sort-dropdown-menu').css('display', 'block');

      if(jQuery(window).width() <= 824){
        jQuery('.tps-sort-dropdown-menu').addClass('tps-sort-dropdown-menu-show');
      }
  }
}
/*** End ***/

/*** Sort By Dropdown Close OnMouseLeave ***/
function sortByClose() {
  jQuery(".tps-sort-dropdown-menu").css('display', 'none');

  if(jQuery(window).width() <= 824){
    jQuery('.tps-sort-dropdown-menu').removeClass('tps-sort-dropdown-menu-show');
  }
}
/*** End ***/

/*** Sort Filter ***/ 
$(document).on("click", ".tps-sort-option", function() {
  sortByClose();
  emptyResultDiv();
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  var sort_field_list = sort_by.replace('_', '-');
  
  jQuery('#sort_call').val(sort_by); 
  jQuery('#sort_dir').val(sort_type);

  jQuery('.tps-sort-icon').removeClass('tps-arrow-up').addClass('tps-arrow-down');
  if(sort_type=="asc"){
      sort_order = translations.titleSortLowToHigh;
      jQuery('.tps-sort-icon-'+sort_field_list).addClass('tps-arrow-down').removeClass('tps-arrow-up');
  }else{
      sort_order = translations.titleSortHightToLow;
      jQuery('.tps-sort-icon-'+sort_field_list).removeClass('tps-arrow-down').addClass('tps-arrow-up');
  }
  jQuery('.tps-sort-by-value').html('<span>'+sort_title+': '+sort_order+'</span>');
  
  jQuery('.tps-sort-option').removeClass('active');
  var sort_field_grid = sort_by+'_'+sort_type.toLowerCase();
  jQuery('.'+sort_field_grid).addClass('active');

  jQuery('#page_no').val(1);
  jQuery('#pagination').val('');
  
  graphqlDataCall();
  
  updateSessionFilters(session_variable+'-other-data','Sort-By',sort_by);
  updateSessionFilters(session_variable+'-other-data','Sort-Direction',sort_type);
});
/*** End ***/

/***Diamond List View Sort Filter Start ***/
function sorting_data(sorting, className) {    
  emptyResultDiv();  
  var sortorder = '';  
  jQuery(".tps-sort-icon").each(function() {
    jQuery(this).hasClass("tps-arrow-up") && jQuery(this).removeClass("tps-arrow-up").addClass("tps-arrow-down")
  }), mySelection[1] == sorting && mySelection[2] == "asc" || mySelection.length == 0 ? (sortorder = "desc", jQuery(className).find("i").removeClass("tps-arrow-down").addClass("tps-arrow-up")) : (sortorder = "asc", jQuery(className).find("i").addClass("tps-arrow-down").removeClass("tps-arrow-up"));
  
    //change grid view dropdown value    
    var sort_value = ''+sorting+'_'+sortorder;     
    var sort_text = jQuery('.'+sort_value).attr('value');
    jQuery('.tps-sort-by-value').text(sort_text);   

    jQuery('.tps-sort-option').removeClass('active');
    var sort_field_grid = sorting+'_'+sortorder;
    jQuery('.'+sort_field_grid).addClass('active');
  
    jQuery('#sort_call').val(sorting);
    jQuery('#sort_dir').val(sortorder);

    mySelection[1] = jQuery('#sort_call').val();
    mySelection[2] = jQuery('#sort_dir').val();
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');
    graphqlDataCall();

    updateSessionFilters(session_variable+'-other-data','Sort-By',sorting);
    updateSessionFilters(session_variable+'-other-data','Sort-Direction',sortorder);
}
/*** End ***/

/*** Sort By Popoup Close In Mobile On Outer Close Start ***/
jQuery(document).on('click','.tps-sort-dropdown-menu-show',function(e){
  var container = $(".tps-mobile-section");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){        
    sortByClose();
  }
});
/*** Sort By Popoup Close In Mobile On Outer Close End ***/

/*** Graphql Call To Get Diamond Data ***/  
function graphqlDataCall(){
   jQuery('.diamond-grid-row').removeClass('tps-recent-viewed-diamond');
   jQuery('.diamond-list-row').removeClass('tps-recent-viewed-diamond');
   var diamond_active_tab = jQuery('#diamond_active_tab').val();
   jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-list-view-loader').css('display','block');
   jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-grid-view-loader').css('display','block');
   jQuery(".tps-dia-count").html("<span class='tps-dia-count-loader'></span>"); //display diamond count loader before diamonds load
   jQuery(".tps-recent-diamonds-tab").addClass("tps-tab-disabled");
   jQuery(".tps-compare-diamonds-tab").addClass("tps-tab-disabled");
  
  var page_no = jQuery('#page_no').val(); 
  var diamond_type = jQuery('#diamond_type').val(); 
  var dia_shape = jQuery('#dia_shape').val();
  var dia_fancy_color = jQuery('#dia_fancy_color').val();
  var dia_report = jQuery('#dia_report').val();   
  var dia_video = jQuery('#dia_video').val(); 
  var carat_min = jQuery("#carat_left_hidden").val();
  var carat_max = jQuery("#carat_right_hidden").val();
  var price_min = jQuery("#budget_left_hidden").val();
  var price_max = jQuery("#budget_right_hidden").val();  
  var color_min = jQuery('#color_min_value').val();
  var color_max = jQuery('#color_max_value').val();
  var clarity_min = jQuery('#clarity_min_value').val();
  var clarity_max = jQuery('#clarity_max_value').val();
  var intensity_min = jQuery('#intensity_min_value').val();
  var intensity_max = jQuery('#intensity_max_value').val();
  var cut_min = jQuery('#cut_min_value').val();
  var cut_max = jQuery('#cut_max_value').val();  
  var fluorescence_min = jQuery('#fluorescence_min_value').val();
  var fluorescence_max = jQuery('#fluorescence_max_value').val();
  var polish_min = jQuery('#polish_min_value').val();
  var polish_max = jQuery('#polish_max_value').val();
  var symmetry_min = jQuery('#symmetry_min_value').val();
  var symmetry_max = jQuery('#symmetry_max_value').val();
  var table_min = jQuery("#table_left_hidden").val();
  var table_max = jQuery("#table_right_hidden").val();
  var depth_min = jQuery("#depth_left_hidden").val();
  var depth_max = jQuery("#depth_right_hidden").val();
  var ratio_min = jQuery("#ratio_left_hidden").val();
  var ratio_max = jQuery("#ratio_right_hidden").val();
  var sort_call = jQuery('#sort_call').val();  
  var sort_dir = jQuery('#sort_dir').val();
  var supplier_name = jQuery('#supplier_name').val();
  var bulk_page_data = getBulkPageDataValuesFromSession();
  var currency_flag = jQuery('#currency_flag').val();
  var diamonds_display_per_page = 12; 
  
  if(diamond_type == 'natural-white' || diamond_type == 'natural-fancy'){
     diamondListingApi = naturalDiamondListingApi;
  }else{
     diamondListingApi = labDiamondListingApi;
  }  
  
  //get values of diamond color selected filters in english 
  var dia_color = '';
  if(session_variable == 'natural-white-diamond' || session_variable == 'lab-white-diamond'){
    dia_color = getSelectedRangeFilterValues(color_min,color_max,'color',default_max_color);
  }else if(session_variable == 'lab-color-diamond' || session_variable == 'natural-color-diamond'){
    dia_color = dia_fancy_color;
  }
  //end  

  //get values of diamond clarity selected filters in english 
  var dia_clarity = getSelectedRangeFilterValues(clarity_min,clarity_max,'clarity',default_max_clarity);   
  //end

  //get values of diamond intensity selected filters in english 
  if(session_variable == 'lab-color-diamond'){
    var dia_intensity = getSelectedRangeFilterValues(intensity_min,intensity_max,'intensity',default_max_intensity);   
  }  
  //end

  //get values of diamond cut selected filters in english 
  var dia_cut = getSelectedRangeFilterValues(cut_min,cut_max,'cut',default_max_cut);  
  //end

  //get values of diamond fluorescence selected filters in english 
  var dia_fluorescence = getSelectedRangeFilterValues(fluorescence_min,fluorescence_max,'fluorescence',default_max_flour); 
  //end  
  
  //get values of diamond polish selected filters in english 
  var dia_polish = getSelectedRangeFilterValues(polish_min,polish_max,'polish',default_max_polish);   
  //end
   
  //get values of diamond symmetry selected filters in english 
  var dia_symmetry = getSelectedRangeFilterValues(symmetry_min,symmetry_max,'symmetry',default_max_symm); 
  //end  
  
  //query parameters for graphql call
  var postdata = JSON.stringify({ query:`{
                  ${diamondListingApi}(page: "` +
              page_no +
              `", pageSize:"`+diamonds_display_per_page+`", shapes:"` +
              dia_shape +
              `", color:"`+ dia_color +`", carat:"` +
              carat_min +
              `, ` +
              carat_max +
              `", clarity:"` +
              dia_clarity +
              `", colorIntensity:"` +
              dia_intensity +
              `", symmetry:"` +
              dia_symmetry +
              `", polish:"` +
              dia_polish +
              `", price:"` +
              price_min +
              `, ` +
              price_max +
              `", cut:"` +
              dia_cut +
              `",fluoroscence:"` +
              dia_fluorescence +
              `",table:"`+table_min+`,`+table_max+`",depthPer:"`+depth_min+`,`+depth_max+`",ratio:"`+ratio_min+`,`+ratio_max+`",currencyFlag:"`+currency_flag+`",lab:"`+dia_report+`", diamondType:"`+diamond_type+`",  bulkPageData:"`+bulk_page_data+`", orderBy:"`+sort_call+`", sortBy:"` +
              sort_dir +`")
                  {
                    dataCount
                    diamondsReturned
                    pageNo
                    diamond{
                      diamondId
                      shape 
                      caratWeight 
                      color 
                      fancyColor 
                      fancyColorIntensity 
                      fancyColorOvertone 
                      clarity 
                      cut 
                      symmetry 
                      polish 
                      deptPerc 
                      tablePerc 
                      length 
                      width 
                      depth 
                      ratio 
                      measurement 
                      girdle 
                      girdleMin 
                      girdleMax 
                      girdleCondition 
                      culet 
                      culetCondition 
                      flourIntensity 
                      certificateFile 
                      lab 
                      finalPriceUsd 
                      markupPriceUsd
                      discountPercentage
                      certificateNumber 
                      stockNumber 
                      diamondImage 
                      diamondVideo 
                      diamondType 
                      currencyCode 
                      currencySymbol 
                      process 
                      }
                      }
                    }
                  `});            
    abortAjax(xhr);
      
    //ajax graphql call for diamonds
    xhr = jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) {    
        var dia_data = response.data[diamondListingApi].diamond;  
        
        var dia_count;
        if(response.data[diamondListingApi].dataCount == null){
          var dia_count = 0;
          var dia_return = 0;
        }else{
          var dia_count = response.data[diamondListingApi].dataCount;
          var dia_return = response.data[diamondListingApi].diamondsReturned;
        }

        jQuery(".tps-load-more-button-refine-results").show();
        getDiamondListView(dia_data,dia_count,dia_return,bulk_page_data,diamonds_display_per_page);          
        
        //diamond info focus return from diamond detail page  
        var session_variable = jQuery("#session_variable").val();
        var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
        if(session_other_data != '' && session_other_data != null){
          if(session_other_data['Single-Recent-Diamond'] != null && session_other_data['Single-Recent-Diamond'] != '' && session_other_data['Single-Recent-Diamond'] != undefined){
            var recentDiamond = session_other_data['Single-Recent-Diamond'][0];
            viewType = session_other_data['View-Type'][0];
            focusRecentDiamond(recentDiamond,viewType);            
          }     
        }
        //end    

      }
    });      

}
/*** End ***/

/*** Check Bulk Page Data Flag For Back TO Serach Diamonds start ***/
function getBulkPageDataValuesFromSession() {
  var bulk_page_data = 'no';
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Recent-Diamond-Page-No'] != undefined && session_other_data['Recent-Diamond-Page-No'][0] != ''){      
      var bulk_page_data = 'no';
      jQuery('#page_no').val(session_other_data['Recent-Diamond-Page-No']);
    }
  }
  return bulk_page_data;
}
/*** Check Bulk Page Data Flag For Back TO Serach Diamonds End ***/

/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if(xhr && xhr.readystate != 4){
    xhr.abort();
  }
}
/*** End ***/

/*** Focus Recently View Diamond Start ***/
function focusRecentDiamond(diamond_id,view_type) {
  var session_variable = jQuery('#session_variable').val();
  if(view_type == 'list'){
     var target = '.diamond-list-item-'+diamond_id;
     openCloseDetailInfo(diamond_id,'all','list','open',target); 
  }else{
    var target = '.diamond-grid-item-'+diamond_id; 
  }
  
  $(target).addClass('tps-recent-viewed-diamond');
  $('html, body').animate({
        scrollTop: $(target).offset().top - 300
  }, 'slow'); 
  
  updateSessionFilters(session_variable+'-other-data','Single-Recent-Diamond', '');
  updateSessionFilters(session_variable+'-other-data','Recent-Diamond-Page-No', '');
  setTimeout(function(){ $(target).removeClass('tps-recent-viewed-diamond'); }, 1000);
}
/*** End ***/

/*** Diamonds Layout Start ***/
function getDiamondListView(allDiamondData,dia_count,dia_return,bulk_page_data,diamonds_display_per_page){  
  var viewType = getViewType();  
  var active_tab = jQuery('#diamond_active_tab').val();
  var page_no = jQuery('#page_no').val(); 
  var pagination = jQuery("#pagination").val();
  
  jQuery(".tps-dia-count").text(addCommas('('+dia_count+')'));  
  jQuery(".tps-total-diamonds").text(addCommas(dia_count));
  
  jQuery("#total_product").val(dia_count);
  jQuery(".tps-load-more-button-section").show();
  jQuery(".tps-load-more").show();

  jQuery(".tps-recent-diamonds-tab").removeClass("tps-tab-disabled");
  jQuery(".tps-compare-diamonds-tab").removeClass("tps-tab-disabled");
    
  var compare_diamonds = [];  
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Compare-Diamonds'] != undefined && session_other_data['Compare-Diamonds'] != null){
      if(session_other_data['Compare-Diamonds'] != null && session_other_data['Compare-Diamonds'] != ''){
        var compare_diamonds = session_other_data['Compare-Diamonds'];
      }
    }
  }
    
  //Diamond List View
  var tableHeadWidthlist = Math.round(100/14);
  jQuery('.table-head').css('width', tableHeadWidthlist + '%');

  if (dia_count == 0) { 
    allDiamondData = null;
  }

  diaListView = '';
  diaGridView = '';
  
  if(allDiamondData != '' && allDiamondData != null){     
    $.each(allDiamondData, function(i, diamondData) { 
       diaListView += getDiamondListingViewLayout(diamondData,compare_diamonds,active_tab);
       diaGridView += getDiamondListingGridLayout(diamondData,compare_diamonds,active_tab,i);
    });    
  }else{
    jQuery(".tps-load-more-button-section").hide();
    jQuery(".tps-diamond-result").addClass("tps-diamond-no-diamond-result-wrapper")
    
    diaListView += '<span class="tps-no-diamond-found">' + translations.titleNoDiamondFound + ' <a class="tps-reset-filter tps-reset-popup" onclick="resetFilters();">Reset Filters</a>' + '</span>';

    diaGridView += '<span class="tps-no-diamond-found">'+translations.titleNoDiamondFound+' <a class="tps-reset-filter tps-reset-popup" onclick="resetFilters();">Reset Filters</a>' + '</span>';

    jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').addClass('tps-no-diamonds-found');
    jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').addClass('tps-no-diamonds-found');
  }

  var diamondListingLayout = diaGridView;
  if(viewType === 'list') {
    diamondListingLayout = diaListView;
  }
    
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-'+viewType+'-view-items-list').html(diamondListingLayout);
 
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-loader').hide();
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-loader').hide();
  $(".tps-diamondlist-voice-search-loader");

  diaListViewBulkData = diaListView; //append new list view html in old variable
  diaGridViewBulkData = diaGridView; //append new grid view html in old variable  

  var totalPages = Math.ceil(dia_count / diamonds_display_per_page);
  renderPagination(page_no, totalPages);

  getSessionSelectedOtherFilterValues();
  assignLazyLoadingToDiamondImages();
  setMediaDivHeight();  
  if ($(window).width() <= 767) {
    setSelectedFilterCountMobile(dia_count); //display selected filter count on mobile filter popoup
  } 

  var pageLoadFlag = jQuery('#page_load').val();
  if(pageLoadFlag != "1"){
    focusFirstRowOnDiamondLoad();     
  }else{
    jQuery('#page_load').val("");
  } 
}
/*** End ***/

/*** Display Selected Filter Count On Mobile Filter Popoup Start  ***/
function setSelectedFilterCountMobile(dia_count){
  if ($('.tps-selected-filter-container').length) {
    var ulCount = $('.tps-selected-filter-container').find('ul').length;

    if (ulCount > 0) {
        jQuery('.tab-shape-carat-price-report').text(translations.titleFiltersSelected+' '+ulCount);    
    }else{
      jQuery('.tab-shape-carat-price-report').text(translations.titleFilters);
    }
  }
  jQuery('.tps-apply-filter-button').text(translations.titleView+' '+addCommas(dia_count)+' '+translations.titleResults);
}
/*** Display Selected Filter Count On Mobile Filter Popoup End  ***/

/*** Get Diamond View Type Start ***/
function getViewType() {
  var session_variable = jQuery('#session_variable').val();
  viewType = 'grid';
  var session_other_data = JSON.parse(localStorage.getItem(session_variable + '-other-data'));            
  if (session_other_data && session_other_data['View-Type']) {
      viewType = session_other_data['View-Type'][0];       
  }    
  return viewType;
}
/*** End ***/

/*** Diamonds Listing Grid Layout Start ***/
function getDiamondListingGridLayout(diamondData,compare_diamonds,active_tab,diamondIndex) {  
  var page_no = jQuery('#page_no').val();
  var banner_display_count = jQuery('#tps_banner_row_count').val();
  var diamond_index = diamondIndex+1;   
  var shop_currency = jQuery('#shop_currency').val();
  var currency_rate = Shopify.currency.rate;
  
  var diamond_id = diamondData.diamondId;
  var diamond_shape = diamondData.shape;
  var diamond_type = getDiamondType(diamondData.diamondType);   
  var diamond_title = getDiamondName(diamondData,diamond_type);   
  var diamond_certificate_url = getCertificateUrl(diamondData); 
  var saving_price = Number(diamondData.markupPriceUsd - diamondData.finalPriceUsd);
      saving_price = Shopify.formatMoney(saving_price * 100, theme.moneyFormat);
      saving_price = saving_price.replace(/([.,])00$/, '');
  var final_price = diamondData[getDiamondDefaultFinalPriceField(shop_currency)];
  var diamond_price = getDiamondPrice(currency_rate,final_price);  

  var comp_final_price = diamondData[getDiamondDefaultComparFinalPriceField(shop_currency)];  
  var compare_price = getDiamondPrice(currency_rate,comp_final_price); 

  var dia_img = diamondData.diamondImage;
  var diamondStockImage = [];
  var diamonGridInfoShow = jQuery('#diamond_grid_info_display').val();
  var diamondImageSrc = getDiamondImage(diamondData,diamond_title);
  var diamondColorValue = (diamondData.color != '' && diamondData.color != undefined) ? diamondData.color : diamondData.fancyColor;
  
  if(dia_img == 'None' ){
     //get diamond stock image url
      $.each(diamondImageUrl, function(i, diamondImage) {   
        if(session_variable == 'natural-white-diamond' || session_variable == 'lab-white-diamond'){
          var imageParam = diamondData.shape.toLowerCase()+'_generic';
        }else{
          var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
        }     
        
        if(diamondImage.includes(imageParam)){    
          diamondStockImage.push(diamondImage);
        }
      });
  }
   
  var compareClass = '';
  if($.inArray(diamondData.diamondId.toString(), compare_diamonds)!=(-1)){
    var compareClass = 'active';            
  }

  diaGrid = '';
  if(active_tab == 'compare'){
    diaGrid += '<li class="tps-diamondlist-result-grid-view-item diamond-grid-row diamond-grid-item-'+diamondData.diamondId+'" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'" data-compare-id="' + diamond_id + '">';
    
  }else{
    diaGrid += '<li class="tps-diamondlist-result-grid-view-item diamond-grid-row diamond-grid-item-'+diamondData.diamondId+'" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'">';
  }
 
  diaGrid += '<div class="tps-diamondlist-item-info-span">';
  diaGrid += '<div class="tps-diamondlist-item-info-span-list">';
    
  if(active_tab == 'all'){
    diaGrid += '<div class="tps-diamondlist-result-grid-compare diamond-compare-'+diamondData.diamondId+' '+compareClass+'">';
    diaGrid += '<input type="checkbox" class="tps-diamondlist-compare-chk diamond-checkbox-'+diamondData.diamondId+'" title="'+translations.titleCompareDiamonds+'" onclick="event.stopPropagation();compareDiamonds(`'+diamond_id+'`);" data-diamond-id="'+diamond_id+'" data-diamond-name="'+diamond_title+'" data-result-list-view-type="grid"><span class="tps-diamondlist-compare-span"></span>';
    diaGrid += '</div>';
  }else if(active_tab == 'compare'){
    diaGrid += '<div class="tps-diamondlist-result-grid-compare diamond-compare-'+diamondData.diamondId+' active">';
    diaGrid += '<input type="checkbox" class="tps-diamondlist-compare-chk diamond-checkbox-'+diamondData.diamondId+'" title="'+translations.titleRemoveCompareDiamonds+'" onclick="event.stopPropagation();removeCompare(`'+diamond_id+'`);" data-diamond-id="'+diamond_id+'" data-diamond-name="'+diamond_title+'" data-result-list-view-type="grid"><span class="tps-diamondlist-compare-span"></span>';
    diaGrid += '</div>';
  }
  if(diamondData.diamondVideo != 'None' && diamondData.diamondVideo != ''){
    diaGrid += '<span class="tps-diamondlist-item-video-play-btn" title="Play Video" onclick="event.stopPropagation();event.preventDefault();playDiamondVideoOnClick(this,`'+diamondData.diamondId+'`);"></span>';
  }
   
  diaGrid += '</div>';
  diaGrid += '</div>';
    
  diaGrid += '<a href="'+tps_config.urls.loose_diamond_detail+'?diamond_id='+diamondData.diamondId+'&diamond_type='+diamondData.diamondType+'" class="tps-diamondlist-item-link" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'" data-title="'+diamond_title+'" data-price="'+diamond_price+'" data-final-price="'+final_price+'" data-comp-price="'+compare_price+'" data-saving-price="'+saving_price+'" data-carat="'+diamondData.caratWeight+'" data-color="'+diamondColorValue+'" data-clarity="'+diamondData.clarity+'" data-cut="'+diamondData.cut+'" data-lab="'+diamondData.lab+'" data-cert-url="'+diamond_certificate_url+'" data-image="'+diamondImageSrc+'" data-shape="'+diamond_shape+'" data-type="'+diamond_type+'">';
  diaGrid += '<div class="tps-diamondlist-item-media-div">';
  diaGrid += getDiamondImageLayout(diamondData,diamond_title);
  if(diamondData.diamondVideo != 'None' && diamondData.diamondVideo != ''){
    diaGrid += '<span class="tps-diamondlist-media-loader" style="display: none;"></span>';
    diaGrid += '<div class="tps-diamondlist-video-iframe-div tps-embed-media-container" style="opacity: 0;">';
    diaGrid += '</div>';
  }
  diaGrid += '</div>';
  diaGrid += '<div class="tps-diamondlist-result-grid-view-cn">'; 
  diaGrid += '<div class="tps-diamondlist-result-grid-title-price">';
  diaGrid += '<span class="tps-diamondlist-item-title">'+diamond_title+'</span>';
  diaGrid += '<div class="tps-diamond-item-price-section">';
  diaGrid += '<span class="tps-diamondlist-item-price">'+diamond_price+'</span>'; 
  if (compare_price != null && compare_price != undefined && compare_price != 0 && compare_price !== ''){
    diaGrid += '<div class="tps-compare-sec"><span class="tps-diamondlist-item-comp-price">'+compare_price+'</span><span class="tps-diamondlist-item-save-price"><label>Save</label>'+saving_price+'</span></div>';
  }  
  diaGrid += '</div>';
  diaGrid += '</div>';
  diaGrid += '<div class="tps-diamondlist-item-meta-data">'; 
  diaGrid += getDiamondMetaInformation(diamondData);
  diaGrid += '</div>';   
  diaGrid += '<div class="tps-diamondlist-item-view-diamond tps-diamondlist-item-view-buttons" style="display:none;>'; 
  diaGrid += '<a href="'+tps_config.urls.loose_diamond_detail+'?diamond_id='+diamondData.diamondId+'&diamond_type='+diamondData.diamondType+'" class="tps-diamondlist-item-detail-view-btn" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'">'+translations.titleMoreInfo+'</a>';
  diaGrid += '<button class="tps-diamondlist-item-detail-add-to-bag tps-qv-choose-btn tps-add-to-bag-diamond tps-add-to-bag-diamond-'+diamondData.diamondId+'" data-id="'+diamondData.diamondId+'" onclick="addToBagDiamond(`'+diamondData.diamondType+'`,`'+diamondData.diamondId+'`,`'+diamondImageSrc+'`);">'+translations.titleAddToBag+'</button>';
  diaGrid += '</div>';   
  diaGrid += '</div>';
  diaGrid += '</a>';

  if(diamonGridInfoShow == 'false'){
    //diamond info layout start
     diaGrid += '<div class="tps-diamondlist-item-info tps-diamond-info-'+diamondData.diamondId+'" style="display:none;">';
     diaGrid += '<span class="tps-diamondlist-item-info-close tps-diamond-info-close" data-id="'+diamondData.diamondId+'" onclick="openCloseDetailInfo(`'+diamond_id+'`,`'+active_tab+'`,`grid`,`close`,event);">close</span>';
     diaGrid += getDiamondInformationLayout(diamondData);
     diaGrid += '</div>';
    //end
  }
  diaGrid += '<input type="hidden" id="tps_diamond_video_'+diamondData.diamondId+'" value="'+diamondData.diamondVideo+'">';
  diaGrid += '</li>';

  //banner start  
  if(jQuery(window).width() > 900 && jQuery(window).width() < 1198){    
    banner_display_count = parseInt(banner_display_count)+1; //for tab view display banner after 21 diamonds
  }
  if(diamond_index == banner_display_count){
      var bannerHtml = $('#tps_banner_blog_'+page_no).html();
      if(bannerHtml != '' && bannerHtml != undefined){
        diaGrid += '<li class="tps-diamondlist-banner-section">';
        diaGrid += '<div class="tps-diamond-listing-page-banner">'+bannerHtml+'</div>';
        diaGrid += '</li>';
      }
  }  
  //banner end
  
  return diaGrid;
}
/*** End ***/

/*** Diamonds List View Layout Start ***/
function getDiamondListingViewLayout(diamondData,compare_diamonds,active_tab) {
  var page_no = jQuery('#page_no').val(); 
  var currency_rate = Shopify.currency.rate;
  var diamond_id = diamondData.diamondId;
  var diamond_shape = diamondData.shape;
  var diamond_type = getDiamondType(diamondData.diamondType);   
  var diamond_title = getDiamondName(diamondData,diamond_type);   
  var diamond_certificate_url = getCertificateUrl(diamondData); 
  var saving_price = Number(diamondData.markupPriceUsd - diamondData.finalPriceUsd);
      saving_price = Shopify.formatMoney(saving_price * 100, theme.moneyFormat);
      saving_price = saving_price.replace(/([.,])00$/, ''); 
  var final_price = diamondData[getDiamondDefaultFinalPriceField(shop_currency)];
  var diamond_price = getDiamondPrice(currency_rate,final_price);  

  var comp_final_price = diamondData[getDiamondDefaultComparFinalPriceField(shop_currency)];  
  var compare_price = getDiamondPrice(currency_rate,comp_final_price);
  var diamondImageSrc = getDiamondImage(diamondData,diamond_title); 
  
  if($.inArray(diamondData.diamondId.toString(), compare_diamonds)!=(-1)){
    var iconChk = 'checked';            
  }else{
    var iconChk = '';
  }
  
  var diaList = '';
  var tableHeadWidth = Math.round(100/14);
  
  if(active_tab == 'compare'){
    diaList += '<li class="tps-diamondlist-result-list-view-item diamond-list-row diamond-list-item-'+diamond_id+'" data-compare-id="'+diamond_id+'">';
  }else{
    diaList += '<li class="tps-diamondlist-result-list-view-item diamond-list-row diamond-list-item-'+diamond_id+'">';
  }
  
  diaList += '<div class="tps-desktop-table-row" onclick="openCloseDetailInfo(`'+diamond_id+'`,`'+active_tab+'`,`list`,`open`,event);">';  

  if(active_tab == 'all'){
    diaList += '<span class="table-data table-data-compare" style="width:'+tableHeadWidth+'%">';  
    diaList += '<i class="tps_checkbox"><input type="checkbox" value="'+diamondData.diamondId+'" data-product-id="'+diamondData.diamondId+'" data-role="none" class="diamond-checkbox-'+diamondData.diamondId+' grid_checkbox" name="idcompare'+diamondData.diamondId+'" data-diamond-name="'+diamond_title+'" value="'+diamondData.diamondId+'"  onclick="event.stopPropagation();compareDiamonds(`'+diamond_id+'`);" '+iconChk+'><span class="tps-diamondlist-compare-span"></span></i>';       
    diaList += '</span>';
  }else if(active_tab == 'compare'){
    diaList += '<span class="table-data table-data-compare" onclick="event.stopPropagation();removeCompare(`'+diamondData.diamondId+'`);" style="width:'+tableHeadWidth+'%"><a href="javascript:void(0)" onclick="event.stopPropagation();removeCompare(`'+diamondData.diamondId+'`);">X</a></span>';
  }
  diaList += '<span class="table-data table-data-shape-image" style="width:'+tableHeadWidth+'%"><span class="tps-shape-icon tps-shape-icon-'+diamond_shape.toLowerCase()+'"></span>';
  
  diaList += '</span>';
  diaList += '<span class="table-data table-data-shape" style="width:'+tableHeadWidth+'%">'+diamond_shape+'</span>';
  diaList += '<span class="table-data table-data-carat" style="width:'+tableHeadWidth+'%">'+diamondData.caratWeight+'</span>';
  if(diamondData.color != ''){
    diaList += '<span class="table-data table-data-color" style="width:'+tableHeadWidth+'%">'+diamondData.color+'</span>';
  }else{
    diaList += '<span class="table-data table-data-color" style="width:'+tableHeadWidth+'%">'+diamondData.fancyColor+'</span>';
  }
  diaList += '<span class="table-data table-data-clarity" style="width:'+tableHeadWidth+'%">'+diamondData.clarity+'</span>';
  diaList += '<span class="table-data table-data-cut tps-table-common-hide" id="cut" style="width:'+tableHeadWidth+'%">'+diamondData.cut+'</span>';
  diaList += '<span class="table-data table-data-polish tps-table-common-hide" id="polish"  style="width:'+tableHeadWidth+'%">'+diamondData.polish+'</span>';
  diaList += '<span class="table-data table-data-fluorescence" id="fluorescence" style="width:'+tableHeadWidth+'%">'+diamondData.flourIntensity+'</span>';
  diaList += '<span class="table-data table-data-symmetry tps-table-common-hide" id="symmetry" style="width:'+tableHeadWidth+'%">'+diamondData.symmetry+'</span>';
  diaList += '<span class="table-data table-data-report" style="width:'+tableHeadWidth+'%">'+diamondData.lab+'</span>';          
  diaList += '<span class="table-data table-data-price" style="width:'+tableHeadWidth+'%">'+diamond_price;
  if (compare_price != null && compare_price != undefined && compare_price != 0 && compare_price !== '') {
    diaList += '<div class="tps-price-wrapper">';
    diaList += '<span class="tps-best-price" onclick="event.stopPropagation();showBestPrice(this);">Best Price</span>';
    diaList += '<span class="tps-diamondlist-item-comp-price" style="display:none;">' + compare_price + '</span>';
    diaList += '<span class="tps-diamondlist-item-save-price" style="display:none;"><label>Save</label>' + saving_price + '</span>';
    diaList += '</div>';
}
  diaList += '</span>';
  diaList += '<span class="table-data table-data-view tps-diamondlist-view-'+diamondData.diamondId+' tps-arrow-down" style="width:'+tableHeadWidth+'%"></span>';  
  diaList += '</div>';
  
  diaList += '<div class="tps-diamondlist-detail-info tps-diamond-detail-info-'+diamondData.diamondId+'" style="display:none;">';
  diaList += '<span class="tps-diamondlist-detail-view-close" data-id="'+diamondData.diamondId+'" onclick="openCloseDetailInfo(`'+diamond_id+'`,`'+active_tab+'`,`list`,`close`,event);">close</span>';
  diaList += '<div class="tps-diamondlist-item-quick-view-wrapper">';  
  diaList += '<div class="tps-diamondlist-detail-view-media">';
  diaList += getDiamondImageLayout(diamondData,diamond_title);  
  diaList += '</div>';

  //diamond info layout start
  diaList += '<div class="tps-diamondlist-detail-view-info-table">';
  diaList += '<span class="tps-diamondlist-detail-view-title">'+diamond_title+'</span>';  
  diaList += '<div class="tps-diamondlist-detail-table-info">';
  diaList += getDiamondInformationLayout(diamondData);
  diaList += '</div>';
  diaList += '</div>';
  //end
  
  diaList += '<div class="tps-diamondlist-detail-view-btn-row">';
  diaList += '<div class="tps-diamondlist-price-sec">';
  diaList += '<span class="tps-diamondlist-detail-view-price">'+diamond_price+'</span>';
  if (compare_price != null && compare_price != undefined && compare_price != 0 && compare_price !== '') {
    diaList += '<span class="tps-diamondlist-item-comp-price">'+compare_price+'</span><span class="tps-diamondlist-item-save-price"><label>Save</label> '+saving_price+'</span>';
  }
  
  diaList += '</div>';
  //diaList += '<div class="tps-finance-option">Pay as little as $37.50 today.<a href="/pages/financing-page" target="_blank">See all financing options</a></div>';
  diaList += '<div class="tps-diamondlist-btn-sec">';
  diaList += '<a href="'+tps_config.urls.loose_diamond_detail+'?diamond_id='+diamondData.diamondId+'&diamond_type='+diamondData.diamondType+'" class="tps-diamondlist-detail-view-btn" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'">'+translations.titleMoreInfo+'</a>';
  diaList += '<button class="tps-diamondlist-item-detail-add-to-bag tps-add-to-bag-diamond tps-add-to-bag-diamond-'+diamondData.diamondId+'" data-id="'+diamondData.diamondId+'" onclick="addToBagDiamond(`'+diamondData.diamondType+'`,`'+diamondData.diamondId+'`,`'+diamondImageSrc+'`);">'+translations.titleAddToBag+'</button>';
  diaList += '</div>';
  diaList += '</div>';
  diaList += '</div>';
  diaList += '</div>';
  
  diaList += '</li>';
  
  return diaList;
}
/*** End ***/

/*** Display best price of diamond in list view start ***/
function showBestPrice(element) {
    var $wrapper = $(element).closest('.tps-price-wrapper');

    $wrapper.find('.tps-best-price').hide();
    $wrapper.find('.tps-diamondlist-item-comp-price').show();
    $wrapper.find('.tps-diamondlist-item-save-price').show();
}
/*** Display best price of diamond in list view end ***/

/*** 360 Video display in Mobile Start ***/
function show360VideoMobile(diamond_id) {  
  jQuery('.diamond-grid-item-'+diamond_id+' .tps-diamondlist-media-loader').show();
  jQuery(".tps-embed-media-container").html("");
  var diamondItemDiv  = jQuery(".diamond-grid-item-"+diamond_id);  
  
  var diamondID = diamond_id; 
  var diamondVideo = jQuery("#tps_diamond_video_"+diamondID).val();    
  if (diamondVideo != '' && diamondVideo != 'None') {
    if (diamondVideo.indexOf("https://loupe360.com/diamond/") > -1){              
      diamondVideo = diamondVideo.replace('/500/500', '/resp/true/autoplay');
    }  
    
     var iframeVideoHTML = `<embed class="tps-diamondlist-video-iframe tps-diamondlist-video-iframe-`+diamondID+`" src="${diamondVideo}" type="text/html" width="${diamondItemDiv.outerWidth()}" height="${diamondItemDiv.outerHeight()}"><div class="tps-video-click-overlay"></div>`;
     jQuery('.diamond-grid-item-'+diamond_id+' .tps-diamondlist-video-iframe-div').html(iframeVideoHTML);

     jQuery('.diamond-grid-item-'+diamond_id+' .tps-diamondlist-detail-img').css('visibility', 'hidden');
     jQuery('.diamond-grid-item-'+diamond_id+' .tps-diamondlist-video-iframe-div').css('opacity', 1); 
     
     jQuery('.diamond-grid-item-'+diamond_id+' .tps-diamondlist-video-iframe').bind('load', function(e) {
       jQuery('.diamond-grid-item-'+diamond_id+' .tps-diamondlist-media-loader').hide();
     });
  }
}
/*** 360 Video display in Mobile End ***/

/*** Grid View On Image Hover 360 Video Display Start ***/ 
jQuery(document).on({
    mouseenter : function(e) {
        if (jQuery(window).width() > 1100) {
            var diamondItemDiv  = jQuery(this);
            var diamondID       = jQuery(this).attr("data-id");  
            diamondItemDiv.find('.tps-diamondlist-item-view-diamond').show(); 

            if (diamondItemDiv.find('.tps-diamondlist-video-iframe').length < 1) {    
                var diamondVideo = jQuery("#tps_diamond_video_"+diamondID).val();    
                if (diamondVideo != '' && diamondVideo != 'None') {
                    if (diamondVideo.indexOf("https://loupe360.com/diamond/") > -1){              
                      diamondVideo = diamondVideo.replace('/500/500', '/resp/true/autoplay');
                    }  
                    displayDiamondVideo(diamondItemDiv, diamondVideo);
                }
            } else if(diamondItemDiv.find('.tps-diamondlist-video-iframe').hasClass('video-loaded')) {     
                switchDiamondImageAndVideo(diamondItemDiv, 'video');
            } 
        }
    },
}, '.tps-diamondlist-result-grid-view-item');
/*** Grid View On Image Hover 360 Video Display End ***/

/*** Grid View On Video Hover Out Image Display Start ***/ 
jQuery(document).on({
    mouseleave : function(e) {
        var diamondItemDiv  = jQuery(this);
        switchDiamondImageAndVideo(diamondItemDiv, 'image');
        diamondItemDiv.find('.tps-diamondlist-item-view-diamond').hide();
    },
}, '.tps-diamondlist-result-grid-view-item');
/*** Grid View On Video Hover Out Image Display End ***/ 

/*** Display Diamond 360 Video Start ***/
function displayDiamondVideo(diamondItemDiv, diamondVideoURL = '') {     
  var iframeVideoHTML = `<embed class="tps-diamondlist-video-iframe" src="${diamondVideoURL}" type="text/html" width="${diamondItemDiv.outerWidth()}" height="${diamondItemDiv.outerHeight()}"><div class="tps-video-click-overlay"></div>`;
  
    diamondItemDiv.find('.tps-diamondlist-media-loader').show();
    diamondItemDiv.find('.tps-diamondlist-video-iframe-div').prepend(iframeVideoHTML);
    diamondItemDiv.find('.tps-diamondlist-video-iframe').bind('load', function(e) {
        if(!diamondItemDiv.find('.tps-diamondlist-video-iframe').hasClass('focus-moved')){
            var currentIframe = jQuery(e.target);
            var mediaDiv    = currentIframe.parents('.tps-diamondlist-item-media-div');     
            mediaDiv.find('.tps-diamondlist-media-loader').hide();
            mediaDiv.find('.tps-diamondlist-detail-img').css('visibility', 'hidden');
            mediaDiv.find('.tps-diamondlist-video-iframe-div').css('opacity', 1); 
        } 
        diamondItemDiv.find('.tps-diamondlist-video-iframe').addClass('video-loaded');
    });
}
/*** Display Diamond 360 Video End ***/

/*** Switch Diamond Image And Video Start ***/
function switchDiamondImageAndVideo(diamondItemDiv, divType = 'image') {    
    if(divType == 'video') {  
        diamondItemDiv.find('.tps-diamondlist-video-iframe-div').css('opacity', 1);
        diamondItemDiv.find('.tps-diamondlist-detail-img').css('visibility', 'hidden');
        diamondItemDiv.find('.tps-diamondlist-video-iframe').removeClass('focus-moved');
    } else {        
        jQuery('.tps-diamondlist-media-loader').hide();
        jQuery('.tps-diamondlist-video-iframe-div').css('opacity', 0);
        jQuery('.tps-diamondlist-detail-img').css('visibility', 'visible');
        diamondItemDiv.find('.tps-diamondlist-video-iframe').addClass('focus-moved');
    }   
}
/*** Switch Diamond Image And Video End ***/
/*** Grid View On Click 360 Video Display (Mobile) Start ***/
function playDiamondVideoOnClick(ele, diamondID) {
    var diamondItemDiv = jQuery(ele).closest('.tps-diamondlist-result-grid-view-item');

    if (diamondItemDiv.find('.tps-diamondlist-video-iframe').length < 1) {
        var diamondVideo = jQuery("#tps_diamond_video_"+diamondID).val();
        if (diamondVideo != '' && diamondVideo != 'None') {
            if (diamondVideo.indexOf("https://loupe360.com/diamond/") > -1){
              diamondVideo = diamondVideo.replace('/500/500', '/resp/true/autoplay');
            }
            displayDiamondVideo(diamondItemDiv, diamondVideo);
            //jQuery(ele).hide(); // hide the play button once the video is showing
        }
    } else if(diamondItemDiv.find('.tps-diamondlist-video-iframe').hasClass('video-loaded')) {
        switchDiamondImageAndVideo(diamondItemDiv, 'video');
        //jQuery(ele).hide();
    }
}
/*** Grid View On Click 360 Video Display (Mobile) End ***/

/*** Tap Video To Go Back To Image (Mobile) Start ***/
jQuery(document).on('click', '.tps-diamondlist-result-grid-view-item .tps-video-click-overlay', function(e) {
    e.stopPropagation();
    var diamondItemDiv = jQuery(this).closest('.tps-diamondlist-result-grid-view-item');
    switchDiamondImageAndVideo(diamondItemDiv, 'image');
    diamondItemDiv.find('.tps-diamondlist-item-video-play-btn').show();
});
/*** Tap Video To Go Back To Image (Mobile) End ***/

/*** Diamonds Meta Information Layout Start ***/
function getDiamondMetaInformation(diamondData) {
  var metaInfo = '';

    if(diamondData.caratWeight != ''){
      metaInfo += '<div class="tps-meta-data-item-wrapper">';      
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.caratWeight+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Carat</span>';
      metaInfo += '</div>';
    }
    if(diamondData.color != ''){
      metaInfo += '<div class="tps-meta-data-item-wrapper">';      
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.color+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Color</span>';
      metaInfo += '</div>';
    }else{
      metaInfo += '<div class="tps-meta-data-item-wrapper">';            
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.fancyColor+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Fancy Color</span>';
      metaInfo += '</div>';
    }    
    if(diamondData.clarity != '' && diamondData.clarity != 'NA'){
      metaInfo += '<div class="tps-meta-data-item-wrapper">';      
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.clarity+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Clarity</span>';
      metaInfo += '</div>';
    }
    if(diamondData.cut != '' && diamondData.cut != 'NA'){
      metaInfo += '<div class="tps-meta-data-item-wrapper">';         
      metaInfo += '<span class="tps-meta-data-item">'+diamondData.cut+'</span>';
      metaInfo += '<span class="tps-meta-data-item-title">Cut</span>';
      metaInfo += '</div>';
    }     
      
  return metaInfo;
}
/*** End ***/

/*** Diamonds Image Layout Start ***/
function getDiamondImageLayout(diamondData,diamond_title) { 
  var session_variable = jQuery('#session_variable').val();
  var diamond_image = diamondData.diamondImage;
  var image = '';
  var diamondStockImage = [];

  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {   
    if(session_variable == 'natural-white-diamond' || session_variable == 'lab-white-diamond'){
      var imageParam = diamondData.shape.toLowerCase()+'_generic';
    }else if(session_variable == 'natural-color-diamond' || session_variable == 'lab-color-diamond'){
      if(diamondData.fancyColor == 'Brown') {
        var imageParam = diamondData.shape.toLowerCase()+'_generic';
      }else{
        var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
      }
    }     
            
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }
  });
  
  if(diamond_image != '' && diamond_image != 'NA' && diamond_image != 'N/A' && diamond_image != 'None' && diamond_image != 'undefined' ){
    image += '<img class="tps-diamondlist-detail-img" data-placeholder-img="'+diamondStockImage[0]+'" alt="'+diamond_title+'" title="'+diamond_title+'" data-src="'+diamond_image+'" src="" width="300" height="300" style="visibility: hidden;">';
  }else{   
    image += '<img class="tps-diamondlist-detail-img" data-placeholder-img="'+diamondStockImage[0]+'" alt="'+diamond_title+'" title="'+diamond_title+'" data-src="'+diamondStockImage[0]+'" src="" width="300" height="300" style="visibility: hidden;">'; 
  }
  return image;
}
/*** Diamonds Layout Start ***/

/*** Diamonds Image Start ***/
function getDiamondImage(diamondData,diamond_title) { 
  var session_variable = jQuery('#session_variable').val();
  var diamond_image = diamondData.diamondImage;
  var image = '';
  var diamondStockImage = [];  
  
  $.each(diamondImageUrl, function(i, diamondImage) {   
      if(session_variable == 'lab-white-diamond'){
        var imageParam = diamondData.shape.toLowerCase()+'_generic';
      }else if(session_variable == 'lab-color-diamond'){
        var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
      }
    
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }
  });
  
  if(diamond_image != '' && diamond_image != 'NA' && diamond_image != 'N/A' && diamond_image != 'None' && diamond_image != 'undefined' ){
    image = diamond_image;
  }else{   
    image = diamondStockImage[0]; 
  }
  return image;
}
/*** Diamonds Start ***/

/*** Change Diamond Listing View Grid/List ***/
function changeResultView(viewType){  
  var active_tab = jQuery('#diamond_active_tab').val();   
  updateSessionFilters(session_variable+'-other-data','View-Type', viewType);
  
  jQuery('.tps-result-view').removeClass('active');
  jQuery('.tps-'+viewType+'-view').addClass('active');  
  
  if(viewType == 'list'){
    jQuery('.tps-diamond-list-view-container').css("display","block");
    jQuery('.tps-diamond-grid-view-container').css("display","none");
    jQuery('.tps-sort-section').css("display","none");
    jQuery('.tps-diamond-listing-add-list-fields-settings-button').css("display","block");
    
  }else{
    jQuery('.tps-diamond-listing-add-list-fields-settings-button').css("display","none");
    jQuery('.tps-diamond-grid-view-container').css("display","block");
    jQuery('.tps-diamond-list-view-container').css("display","none");
    if(jQuery('.tps-all-diamonds-tab').hasClass('active-tab')){
      jQuery('.tps-sort-section').css("display","block");
    }else{
      jQuery('.tps-sort-section').css("display","none");
    }

    assignLazyLoadingToDiamondImages();
    setMediaDivHeight();  
    
  }

  jQuery('.tps-list-table-header').removeClass("sticky-list");
  
  if(active_tab == 'all'){
    addStickyDiamondListGridHeader();
    setDiamondLayout(viewType);
  }    
  
}
/*** End ***/

/*** Set Diamond Layout Onclick Diamond View Type Start ***/
function setDiamondLayout(viewType){  
  var active_tab = jQuery('#diamond_active_tab').val();   

  var diamondListingLayout = diaGridViewBulkData;
  if(viewType == 'list') {
    diamondListingLayout = diaListViewBulkData;
  }
  
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-'+viewType+'-view-items-list').html('');
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-'+viewType+'-view-items-list').append(diamondListingLayout);

  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-'+viewType+'-view-loader').hide();

  assignLazyLoadingToDiamondImages();
  setMediaDivHeight();  
}
/*** Set Diamond Layout Onclick Diamond View Type End ***/

/*** Set Grid View Media Div As Height Start ***/
function setMediaDivHeight() { 
    jQuery('.tps-diamondlist-item-media-div').each(function () {
        var width = jQuery(this).outerWidth();
        jQuery(this).height(width);
    });
}
/*** Set Grid View Media Div As Height End ***/

/*** Display None block functionality for the filter icon add **/
$(document).ready(function () {
    function toggleFilterVisibility() {
        if ($(window).width() <= 767) {
            $(".diamond-listing-filters").hide(); // Hide on mobile
        } else {
            $(".diamond-listing-filters").show(); // Show on desktop
        }
    }

    // Run on page load
    toggleFilterVisibility();

    // Run on window resize
    $(window).resize(function () {
        toggleFilterVisibility();
    });   
    
    addStickyDiamondListGridHeader();
});
/*** End ***/

/*** Make Diamond Listing Header Top Sticky Start ***/
function addStickyDiamondListGridHeader(){      
  var tableList = jQuery(".tps-list-table-header");
  var tableGrid = jQuery(".tps-diamond-listing-tabs-sort-by-switcher");	
  var listOffset = tableList.length ? tableList.offset().top : 0;
  var gridOffset = tableGrid.length ? tableGrid.offset().top : 0;	
  var diamondResultView = getViewType();

  jQuery(window).on("scroll", function () {
    jQuery('.tps-popup-adding-filter-list-view').css('display', 'none');
    var scrollTop = jQuery(window).scrollTop();		
    if (diamondResultView == 'list' && tableList.length) {
        tableList.toggleClass("sticky-list", scrollTop > listOffset);
    }
    if (tableGrid.length) {
        tableGrid.toggleClass("sticky", scrollTop > gridOffset);
    }
  });
}
/*** End ***/

/*** Diamond List & Grid View Detail Info Ope Close ***/
function openCloseDetailInfo(diamond_id,active_tab,display_type,action,ele) {    
  var active_tab = jQuery('#diamond_active_tab').val();
  if(display_type == 'grid'){  
    if(action == 'open'){
      jQuery('.tps-diamondlist-item-info').css("display", "none");
      jQuery('.tps-diamond-info-'+diamond_id).slideDown('slow');
    }else{
      jQuery('.tps-diamond-detail-info-'+diamond_id).slideUp('slow');
      jQuery('.tps-diamond-info-'+diamond_id).slideUp('slow');
    }      
  }else{
    
    if(jQuery('.diamond-list-item-'+diamond_id).hasClass("diamond-row-active")){
      action = 'close';
    }
   
     var container = $(".tps-diamondlist-item-quick-view-wrapper"); //diamond info container   
     jQuery('.table-data-view').removeClass("tps-arrow-up").addClass('tps-arrow-down');

     // If the target of the click isn't the container
     if(!container.is(ele.target) && container.has(ele.target).length === 0){         
        if(action == 'open'){   
          jQuery('.tps-diamondlist-detail-info').slideUp('slow'); 
          jQuery('.tps-diamondlist-result-list-view-item').removeClass("diamond-row-active");
          
          jQuery('.diamond-list-item-'+diamond_id).addClass("diamond-row-active"); 
          jQuery('.tps-diamond-detail-info-'+diamond_id).slideDown('slow'); 
          jQuery('.tps-diamondlist-view-'+diamond_id).removeClass('tps-arrow-down').addClass('tps-arrow-up');  

          var target = '.tps-'+active_tab+'-diamond-data .diamond-list-item-'+diamond_id;
      
          //adjust scroll position when diamond info display    
          jQuery('html, body').animate({
              scrollTop: jQuery(target).offset().top - 480
          }, 150);              
          //end
          
        }else{
          jQuery('.table-data-view').removeClass("tps-arrow-up").addClass('tps-arrow-down');
          jQuery('.tps-diamondlist-detail-info').css("display", "none");            
          jQuery('.diamond-list-row').removeClass("diamond-row-active");
        }
     }         
  }  
}
/*** End ***/

/*** Reset Filters Start ***/
function resetFilters(flag){
  var diamond_type = jQuery('#diamond_type').val();
  var session_variable = jQuery("#session_variable").val();
  localStorage.removeItem(session_variable+'-filters');   
  localStorage.setItem('resetFlag', 'true');
  jQuery(".tps-reset-filter-confirm-popup-div").hide();

  var tableTitle = translations.titleTable.replace(' %', '');
  var depthTitle = translations.titleDepth.replace(' %', '');    
  
  if(typeof(Storage) !== "undefined"){
    $('.tps-selected-filter-wrapper').hide();
    $('.tps-selected-filter-container ul').remove();
    
    $('.tps-filter-shape-li').removeClass('selected');
    $(".tps-filter-shape-checkbox").prop('checked', false);
    $('#dia_shape').val('');       

    $('.tps-filter-fancy-color-li').removeClass('selected');
    $(".tps-filter-fancy-color-checkbox").prop('checked', false);
    $('#dia_fancy_color').val(default_fancy_colour);
    
    $('.tps-filter-report-li').removeClass('selected');
    $(".tps-filter-report-checkbox").prop('checked', false);
    $('#dia_report').val('');

    $('.tps-filter-looking-li').removeClass('selected');
    $(".tps-filter-looking-checkbox").prop('checked', false);
    $('#dia_looking').val('');

    $('.tps-filter-media-li').removeClass('selected');
    $(".tps-filter-media-checkbox").prop('checked', false);
    $('#dia_media').val('');

    $('.tps-filter-quickship-li').removeClass('selected');
    $(".tps-filter-quickship-checkbox").prop('checked', false);
    $('#dia_quickship').val('');   

    $('.tps-3x-button').removeClass('active');
    $(".tps-3x-button").prop('checked', false);

    $('.tps-filter-list-view').removeClass('selected');
    $('.tps-table-common-hide').removeClass('visible');

    carat_slider_render(default_carat_min, default_carat_max, true, translations.titleCarat); 
    price_slider_render(default_price_min, default_price_max, true, translations.titlePrice);     
    clarity_slider_render(0, default_max_clarity, true, translations.titleClarity);
    cut_slider_render(0, default_max_cut, true, translations.titleCut);
    polish_slider_render(0, default_max_polish, true, translations.titlePolish);
    symmetry_slider_render(0, default_max_symm, true, translations.titleSymmetry); 
    table_slider_render(default_table_min, default_table_max, true, tableTitle);
    depth_slider_render(default_depth_min, default_depth_max, true, depthTitle); 
    ratio_slider_render(default_ratio_min, default_ratio_max, true, translations.titleRatio);
    fluorescence_slider_render(0, default_max_flour, true, translations.titleFluorescence);
    if(session_variable == 'lab-color-diamond'){
      intensity_slider_render(0, default_max_intensity, true, translations.titleIntensity);
    }         
    if(session_variable == 'natural-white-diamond' || session_variable == 'lab-white-diamond'){
      color_slider_render(0, default_max_color, true, translations.titleColor);
    }

    $(".tps-setting-column").prop('checked', false);
    $(".tps-filter-list-view").removeClass('selected');
    jQuery('.table-head').removeClass("visible");
    jQuery('.table-data').removeClass("visible");
    updateSessionFilters(session_variable+'-other-data','List-Column', '');

    $('#sort_dir').val('asc');    
    $('#sort_call').val('final_price_usd');
    $('.tps-sort-option').removeClass('active');
    $('.final_price_usd_asc').addClass('active');
    $('.tps-sort-icon').removeClass('tps-arrow-up').addClass('tps-arrow-down');
    jQuery('.tps-sort-by-value').html('<span>'+translations.titlePriceSortLowToHigh+'</span>');
    updateSessionFilters(session_variable+'-other-data','Sort-By', 'final_price_usd');
    updateSessionFilters(session_variable+'-other-data','Sort-Direction', 'asc');
    
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');   
    graphqlDataCall();
    setCutFilterVisibility('');

    setTimeout(function(){
      localStorage.setItem('resetFlag','false');
    }, 1000);
  }
}
/*** End ***/

/*** Check Reset Flag Start ***/
function checkResetFlag() {
  var resetFlag = localStorage.getItem('resetFlag');
  return resetFlag;
}
/*** Check Reset Flag End ***/

/*** Get Closest Number From Array ***/
function getClosestNum(num, ar) {
  var i = 0,
    closest, closestDiff, currentDiff;
  if (ar.length) {
    closest = ar[0];
    for (i; i < ar.length; i++) {
      closestDiff = Math.abs(num - closest);
      currentDiff = Math.abs(num - ar[i]);
      if (currentDiff < closestDiff) {
        closest = ar[i];
      }
      closestDiff = null;
      currentDiff = null;
    }
      
    //returns first element that is closest to number
    return closest;
  }
  //no length
  return false;
}
/*** End ***/

/*** Get Array Index Value ***/  
function get_index(value, array) {
  var pos = 0
  for (i = 0; i < array.length; i++) {
    if (array[i] == value) {
      pos = i;
      break;
    }
  }
  return pos;
}
/*** End ***/

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** Create & Update Session Filters Array Start ***/
function updateSessionFilters(arrayKey, filterKey, newValues) {
    // Retrieve the filters object from local storage or initialize an empty object
    let filters = JSON.parse(localStorage.getItem(arrayKey)) || {};

    // Split the newValues string by commas to handle multiple values
    let newValuesArray = newValues.split(',').map(value => value.trim());
 
    // Replace the old values with new ones
    filters[filterKey] = newValuesArray;
 
    // Save the updated filters object back to local storage
    localStorage.setItem(arrayKey, JSON.stringify(filters));
}
/*** Create & Update Session Filters Array End ***/

/*** Insert Session Selected Values In Input Fields Start ***/
function getSessionSelectedFilterValues(session_data) {  
    // Restore the Report Number on Page Load
    var session_variable = jQuery("#session_variable").val();
    var newreportno = session_variable + '-filters';
    var savedFilters = localStorage.getItem(newreportno); 

    if (savedFilters) {
      var filtersObj = JSON.parse(savedFilters);         
    }

    // Apply session filters
    var checkboxTypeFilters = ['Shape','Certificate']; 
    if (session_variable === "lab-color-diamond"){
      checkboxTypeFilters.push('Color');
    }

    $.each(session_data, function(key, value) { 
        var inputKey = key.toLowerCase();
        
        if (checkboxTypeFilters.indexOf(key) !== -1) {    

            if (value !== '') {
                var inputValues = value.toString();
                
                if (key === 'Color') {
                    $('#dia_fancy_color').val(inputValues);               
                } else {
                    $('#dia_' + inputKey).val(inputValues);
                }

                var filterArrayKey = key;
                var filterArrayValues = value;

                setTimeout(function() { 
                    setSessionSelectedCheckBoxFilters(filterArrayKey, filterArrayValues);
                    var dia_shape = $('#dia_shape').val();
                    setCutFilterVisibility(dia_shape);
                }, 50);  
            }

        } else if (key === 'Budget' || key === 'Carat' || key === 'Table' || key === 'Depth' || key === 'Ratio') {
            $('#' + inputKey + '_left_hidden').val(value[0]);
            $('#' + inputKey + '_right_hidden').val(value[1]);

        } else {            
            $('#' + inputKey + '_min_value').val(value[0]);
            $('#' + inputKey + '_max_value').val(value[1]);
        }    
    });    
}
/*** Insert Session Selected Values In Input Fields End ***/

/*** Set Session Selected Sort Filter Start ***/
function setSessionSelectedSortValues(sortBy,sortDirection) {  
  var sort_field_list = sortBy.replace('_', '-');
  
  if(sortDirection=="asc"){
      sort_order = translations.titleSortLowToHigh;
      jQuery('.tps-sort-icon-'+sort_field_list).addClass('tps-arrow-down').removeClass('tps-arrow-up');
  }else{
      sort_order = translations.titleSortHightToLow;
      jQuery('.tps-sort-icon-'+sort_field_list).removeClass('tps-arrow-down').addClass('tps-arrow-up');
  } 
  
  jQuery('.tps-sort-option').removeClass('active');
  var sort_field_grid = sortBy+'_'+sortDirection.toLowerCase();
  jQuery('.'+sort_field_grid).addClass('active');

  var sort_text = jQuery('.'+sort_field_grid).attr('value');
  jQuery('.tps-sort-by-value').html(sort_text);
}
/*** Set Session Selected Sort Filter End ***/

/*** Set Session Selected Checkbox Type Filters Start ***/
function setSessionSelectedCheckBoxFilters(filterKey,filterValues) {
  $(filterValues).each(function(index, value) {        
      var filterTitle = filterKey.toLowerCase();
      var filterValue = value.replace(/\s+/g, '-').toLowerCase();

      if(filterValue != '' && filterValue != null && filterValue != undefined){
          if (session_variable === "lab-color-diamond"){
            if(filterTitle == 'color'){
              filterTitle = 'fancy-color';
            }   
          }  
                     
          $(".tps-filter-"+filterTitle+"-checkbox-"+filterValue).prop('checked', true);
          $(".tps-filter-"+filterTitle+"-"+filterValue).addClass('selected'); 
           
          var filterSelectedValues = filterKey+': '+value;           
          setSelectedFilter(filterSelectedValues,"remove"+filterKey+"Filter('"+value+"')",true,value);  
      }
         
   });  
}
/*** Set Session Selected Checkbox Type Filters End ***/

/*** Onclick Diamond Listing Grid Recent Diamond Detail Stored in Session Start ***/
$(document).on("click", ".tps-diamondlist-result-grid-view-item a.tps-diamondlist-item-link", function(e) {  
  var diamond_id = $(this).attr("data-id");  
  var diamond_page = $(this).attr("data-page");
  setRecentProductData(diamond_id,diamond_page);

  //On mobile, open the quick view popup instead of redirecting to the diamond detail page
  if(jQuery(window).width() <= 767){
    e.preventDefault();
    openDiamondQuickViewPopup($(this));
  }
});
/*** Onclick Diamond Listing Grid Recent Diamond Detail Stored in Session End ***/

/*** Onclick Diamond Listing Recent Diamond Detail Stored in Session Start ***/
$(document).on("click", ".tps-diamondlist-detail-view-btn", function() {
  var diamond_id = $(this).attr("data-id");  
  var diamond_page = $(this).attr("data-page");
  setRecentProductData(diamond_id,diamond_page);
});
/*** Onclick Diamond Listing Recent Diamond Detail Stored in Session End ***/

/*** Recently viewd Diamond Stored in Session Start ***/
function setRecentProductData(diamond_id,diamond_page){
  //store single recently viewed diamond 
  updateSessionFilters(session_variable+'-other-data','Single-Recent-Diamond', diamond_id);
  updateSessionFilters(session_variable+'-other-data','Recent-Diamond-Page-No', diamond_page);
  //end

  //store recently viewed diamonds 
  var products_ids = '';
  if(session_other_data['Recent-Diamonds'] != null && session_other_data['Recent-Diamonds'] != ''){
    var products_ids = session_other_data['Recent-Diamonds'];
    products_ids = products_ids.toString();
  }
 
  var recentDiamondsData = [];
  if (products_ids == "" || products_ids == null) {
    var recent_diamonds = [];
  } else {
    recent_diamonds = products_ids.split(",");
  }

  if (jQuery.inArray(diamond_id.toString(), recent_diamonds) == (-1)) {
    recent_diamonds.push(diamond_id);
  }else{
    
  } 
  
  updateSessionFilters(session_variable+'-other-data','Recent-Diamonds', recent_diamonds.toString());
  //end  
}
/*** Recently viewd Diamond Stored in Session End ***/

/*** Get Recent Diamonds Tab Active Start ***/
function getRecentDiamonds() {
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  
  if(session_other_data['Recent-Diamonds'] != null && session_other_data['Recent-Diamonds'] != undefined){
    var recentDiamonds = session_other_data['Recent-Diamonds'].toString();
    var recentCount = session_other_data['Recent-Diamonds'].length;
    var ViewType = session_other_data['View-Type'][0];
    
    showLoader('recent');
    jQuery("#diamond_active_tab").val('recent');
    jQuery(".tps-diamond-result-data").hide();
    jQuery(".tps-recent-diamond-data").show();
    jQuery(".tps-listing-tabs").removeClass('active-tab');
    jQuery(".tps-recent-diamonds-tab").addClass('active-tab');
    getCompareRecentDataCall(recentDiamonds,'recent');
  }else{
    alert(translations.titleRecentlyViewedDiamondsNotFound);
    return false;
  }  
}
/*** Get Recent Diamonds Tab Active End ***/

/*** Add Diamond For Compare ***/
function compareDiamonds(id) {
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  var diamond_name = jQuery('.diamond-checkbox-'+id).attr('data-diamond-name');
  
  var compareArray = [];
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Compare-Diamonds'] != null && session_other_data['Compare-Diamonds'] != ''){
      var compareArray = session_other_data['Compare-Diamonds'];
    }
  }

  if(jQuery.inArray(id.toString(),compareArray)==(-1)){
     if(jQuery('.diamond-checkbox-'+id).is(':checked')){
        compareArray.push(id); 
        jQuery('.diamond-compare-'+id).addClass('active');

        //display toast message when diamond added for compare
        jQuery('.tps-toast-msg-content').html(diamond_name+' '+translations.titleAddedForCompare);           
         $(".tps-toast-msg-popup-wrapper").addClass("tps-popoup-show");
        setTimeout(function() { $(".tps-toast-msg-popup-wrapper").removeClass('tps-popoup-show'); }, 2000);

        if(jQuery('.tps-grid-view').hasClass('active')){        
          jQuery('.diamond-checkbox-'+id).prop('checked', true);   
        }
     }
  }else{
      compareArray.splice(compareArray.indexOf(id.toString()), 1);
      jQuery('.diamond-compare-'+id).removeClass('active');

      //display toast message when diamond remove from compare
      jQuery('.tps-toast-msg-content').html(diamond_name+' '+translations.titleremovedFromCompare);
      $(".tps-toast-msg-popup-wrapper").addClass("tps-popoup-show");
      setTimeout(function() { $(".tps-toast-msg-popup-wrapper").removeClass('tps-popoup-show'); }, 2000);

      if(jQuery('.tps-grid-view').hasClass('active')){        
        jQuery('.diamond-checkbox-'+id).prop('checked', false);   
      }
  }
  
  updateSessionFilters(session_variable+'-other-data','Compare-Diamonds', compareArray.toString());
  
  var compareCount = compareArray.length;
  jQuery(".tps-compare-count").html("("+compareCount+")"); 

  // AI Diamonds Search Compare Diamonds 
  var userType = jQuery('#tps-ai-chat-user-type').val();
  if(jQuery('.tps-Ai-mode-popup').hasClass(userType)){
    if(compareCount == 0){
      jQuery(".tps-ai-compare-diamonds").css("display","none");
    }else{
      jQuery(".tps-ai-compare-diamonds").css("display","flex");
    }    
  }

}
/*** End ***/

/*** Get Compare Diamonds Start ***/
function getCompareDiamonds() {  
  
  jQuery('.tps-compare-diamond-data .tps-diamondlist-result-list-view-items-list').removeClass('tps-no-diamonds-found');
  jQuery('.tps-compare-diamond-data .tps-diamondlist-result-grid-view-items-list').removeClass('tps-no-diamonds-found');
  
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data['Compare-Diamonds'] != null && session_other_data['Compare-Diamonds'] != undefined){
    var compareDiamonds = session_other_data['Compare-Diamonds'].toString();
    var compareCount = session_other_data['Compare-Diamonds'].length;
    var ViewType = session_other_data['View-Type'][0];

    if(session_other_data['Compare-Diamonds'].length == 1 && session_other_data['Compare-Diamonds'][0] == ''){
      alert(translations.titleCompareDiamondsNotFound);
      return false;
    }
    
    showLoader('compare');
    jQuery("#diamond_active_tab").val('compare');
    jQuery(".tps-diamond-result-data").hide();
    jQuery(".tps-compare-diamond-data").show();
    jQuery(".tps-listing-tabs").removeClass('active-tab');
    jQuery(".tps-compare-diamonds-tab").addClass('active-tab');
    
    getCompareRecentDataCall(compareDiamonds,'compare');    
  }else{
    alert(translations.titleCompareDiamondsNotFound);
    return false;
  }    

  // AI Diamonds Search Compare Diamonds 
  var userType = jQuery('#tps-ai-chat-user-type').val();
  if(jQuery('.tps-Ai-mode-popup').hasClass(userType)){
    jQuery(".tps-ai-diamond-grid-loader .tps-diamondlist-result-grid-view-loader").show();
  }
}
/*** Get Compare Diamonds End ***/

/*** Remove Diamonds From Compare Start ***/
function removeCompare(id) {  
  var active_tab = jQuery("#diamond_active_tab").val(); 
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Compare-Diamonds'] != null && session_other_data['Compare-Diamonds'] != ''){
      var compareArray = session_other_data['Compare-Diamonds'];
    }
  }
  compareArray.splice(compareArray.indexOf(id.toString()), 1);
  
  var compareCount = compareArray.length;
  jQuery(".tps-compare-count").html("("+compareCount+")"); 
  
  updateSessionFilters(session_variable+'-other-data','Compare-Diamonds', compareArray.toString());    
  jQuery("[data-product-id='" + id + "']").prop('checked', false);

  if(compareCount == 0){    
     var diaListView = '<span class="tps-no-diamond-found">'+translations.titleDiamondNotFoundForCompare+' <a class="tps-reset-filter tps-reset-popup" onclick="resetFilters();">Reset Filters</a>' + '</span>'; 
     var diaGridView = '<span class="tps-no-diamond-found">'+translations.titleDiamondNotFoundForCompare+' <a class="tps-reset-filter tps-reset-popup" onclick="resetFilters();">Reset Filters</a>' + '</span>';

     jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').addClass('tps-no-diamonds-found');
     jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').addClass('tps-no-diamonds-found');

     jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html(diaListView);
     jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html(diaGridView);    
  }

  //display toast message when diamond remove from compare
  var diamond_name = jQuery('.diamond-checkbox-'+id).attr('data-diamond-name');
  jQuery('.tps-toast-msg-content').html(diamond_name+' '+translations.titleremovedFromCompare);
  jQuery(".tps-toast-msg-popup-wrapper").addClass("tps-popoup-show");

  jQuery('.diamond-compare-'+id).removeClass('active');
  jQuery("[data-compare-id='"+id+"']").remove();

  setTimeout(function() { $(".tps-toast-msg-popup-wrapper").removeClass('tps-popoup-show'); }, 2000);
}
/*** Remove Diamonds From Compare End ***/

/*** Close Compare Message Popup Start ***/
function closePopup() {
  $(".tps-toast-msg-popup-wrapper").removeClass("tps-popoup-show");
}
/*** Close Compare Message Popup End ***/

/*** Graphql API Call To Get Diamond For Compare & Recent Diamonds Start ***/
function getCompareRecentDataCall(diamond_data,flag) {   
  var diamond_type = jQuery('#diamond_type').val(); 
  if(diamond_type == 'natural-white' || diamond_type == 'natural-fancy'){
     diamondDetailApi = naturalDiamondDetailApi;
  }else{
     diamondDetailApi = labDiamondDetailApi;
  } 
  
  var active_tab = flag;
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html('');
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html('');
  
  //query parameters for graphql call
  var postdata = JSON.stringify({
      query: `{
                  ${diamondDetailApi}(diamondId: "` + diamond_data +`",diamondType: "`+ diamond_type +`")
                  {                    
                   diamond{
                      diamondId
                      shape 
                      caratWeight 
                      color 
                      fancyColor 
                      fancyColorIntensity 
                      fancyColorOvertone 
                      clarity 
                      cut 
                      symmetry 
                      polish 
                      deptPerc 
                      tablePerc 
                      length 
                      width 
                      depth 
                      ratio 
                      measurement 
                      girdle 
                      girdleMin 
                      girdleMax 
                      girdleCondition 
                      culet 
                      culetCondition 
                      flourIntensity 
                      certificateFile 
                      lab 
                      finalPriceUsd 
                      markupPriceUsd
                      discountPercentage
                      certificateNumber
                      stockNumber 
                      diamondImage 
                      diamondVideo 
                      diamondType 
                      currencyCode 
                      currencySymbol 
                      process 
                        similarDiam{ 
                          diamondId 
                          shape 
                          caratWeight 
                          color 
                          fancyColor 
                          fancyColorIntensity 
                          fancyColorOvertone 
                          clarity 
                          cut 
                          symmetry 
                          polish 
                          deptPerc 
                          tablePerc 
                          length 
                          width 
                          depth 
                          ratio 
                          measurement 
                          girdle 
                          girdleMin 
                          girdleMax 
                          girdleCondition 
                          culet 
                          culetCondition 
                          flourIntensity 
                          certificateFile 
                          lab 
                          finalPriceUsd 
                          certificateNumber 
                          stockNumber 
                          diamondImage 
                          diamondVideo 
                          diamondType 
                          currencyCode 
                          currencySymbol
                          process 
                        } 
                   }
                  }
                  }
                  `
    });
    abortAjax(xhr);  
    xhr = jQuery.ajax({ 
        url: api,
        contentType: "application/json",
        type: 'POST',
        data: postdata,
        success: function(response) {
            var allDiamondData = response.data[diamondDetailApi].diamond;            
            if(active_tab == 'recent'){
              jQuery('.tps-'+active_tab+'-diamond-data .table-head-compare').remove();
            }else{
              jQuery('.tps-'+active_tab+'-diamond-data .table-head-compare').html(translations.titleRemove);
            }
          
            var diaListView = '';
            var diaGridView = '';            
            
            $.each(allDiamondData, function(i, diamondData) { 
               diaListView += getDiamondListingViewLayout(diamondData,'',active_tab);
               diaGridView += getDiamondListingGridLayout(diamondData,'',active_tab,i);
            });                       

            jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html(diaListView);
            jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html(diaGridView);

            jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-loader').hide();
            jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-loader').hide();

            jQuery(".tps-ai-diamond-grid-loader .tps-diamondlist-result-grid-view-loader").hide();
            assignLazyLoadingToDiamondImages();            
            setMediaDivHeight();
        }
    });

}
/*** End ***/

/*** Get All Diamonds Tab Active ***/ 
function getAllDiamonds(){
  jQuery("#diamond_active_tab").val('all');
  jQuery(".tps-diamond-result-data").hide();
  jQuery(".tps-all-diamond-data").show();
  jQuery(".tps-listing-tabs").removeClass('active-tab');
  jQuery(".tps-all-diamonds-tab").addClass('active-tab');
  setMediaDivHeight();

  jQuery('.tps-all-diamond-data .tps-diamondlist-result-list-view-loader').hide();
  jQuery('.tps-all-diamond-data .tps-diamondlist-result-grid-view-loader').hide();
}
/*** End ***/

/*** Refine Your Results Focus To Filter Section ***/
function refineYourResults(){
  var target = '.tps-filter-container'; 
  $('html, body').animate({
        scrollTop: $(target).offset().top - 250
  }, 'slow'); 
}
/*** End ***/

/*** Assign Lazy Loading To Grid View Result Diamond Images Start ***/
function assignLazyLoadingToDiamondImages() {
  jQuery('.tps-diamondlist-detail-img').Lazy({  			
      visibleOnly : true,
      bind : 'scroll',
      threshold : 0,
      onError : function(imgEle) {
          imgEle.attr('src', imgEle.data('placeholder-img'));
      },
      beforeLoad : function(imgEle) {  				
        imgEle.css('visibility', 'visible');
      },
  });
}
/*** Assign Lazy Loading To Grid View Result Diamond Images End ***/

/*** List Column Setting Dropdown Open Close Start ***/
function listColoumnSettingOpen() {
  if(jQuery('.tps-popup-adding-filter-list-view').css('display') !== 'none'){    
      jQuery('.tps-popup-adding-filter-list-view').css('display', 'none');
  }else {   
      jQuery('.tps-popup-adding-filter-list-view').css('display', 'block');
  }
}
/*** End ***/

/*** Show Hide Extra List View Column Data using Setting Start ***/
$(document).on("click", ".tps-filter-list-view", function() {
  jQuery('.tps-popup-adding-filter-list-view').css('display', 'none');
  
  var column_title = jQuery(this).attr("data-value");
  var columnHeadingClass = 'table-head-'+column_title;
  var columnDataClass = 'table-data-'+column_title;
 
  //show hide table heading & coloumn data start
  if(jQuery(this).hasClass("selected")){
    jQuery(this).removeClass("selected");
    jQuery('.'+columnHeadingClass).removeClass("visible");
    jQuery('.'+columnDataClass).removeClass("visible");
  }else{
    jQuery(this).addClass("selected");
    jQuery('.'+columnHeadingClass).addClass("visible");
    jQuery('.'+columnDataClass).addClass("visible");
  }

  //store selected column info in session
  var column_values = [];
  var list_column = '';
  jQuery(".tps-popup-adding-filter-list-view input:checkbox" ).each(function(){
    if(jQuery(this).is(':checked')){
      check_variable = jQuery(this).attr('data-value'); 
      column_values.push(check_variable);
      // 
    }
  });

  list_column = column_values.join(',');
  updateSessionFilters(session_variable+'-other-data','List-Column', list_column);  
});
/*** End ***/

/*** Set Session List View Column Start ***/
function getSessionSelectedOtherFilterValues(){
  var session_variable = jQuery("#session_variable").val();
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));

  // Apply session filters
    $.each(session_other_data, function(key, value) {  
      if(key == "List-Column" && value.length > 0){        
        var list_column = value;

        $.each(list_column, function(key, column) {  
          if(column != ''){
            setTimeout(function() {       
              var columnHeadingClass = 'table-head-'+column;              
              var columnDataClass = 'table-data-'+column;

              jQuery('.'+columnHeadingClass).addClass("visible");
              jQuery('.'+columnDataClass).addClass("visible");

              $(".tps-"+column+"-filter-list-view").prop('checked', true);
              $(".tps-filter-list-view-"+column).addClass('selected');
            }, 50);
          }
           
        });
      }
    });
}
/*** End ***/

/*** Pagination: render page numbers ***/
function renderPagination(currentPage, totalPages){
  currentPage = parseInt(currentPage);
  totalPages = parseInt(totalPages);
  jQuery('#total_pages').val(totalPages);

  if(totalPages <= 1){
    jQuery('#tps_pagination_section').html('');
    return;
  }

  var html = '';
  html += '<span class="tps-pagination-prev'+(currentPage <= 1 ? ' disabled' : '')+'" onclick="goToPage('+(currentPage-1)+')">&lsaquo;</span>';

  var pages = getPaginationRange(currentPage, totalPages);
  jQuery.each(pages, function(i, p){
    if(p == '...'){
      html += '<span class="tps-pagination-ellipsis">...</span>';
    }else{
      html += '<span class="tps-pagination-item'+(p == currentPage ? ' active' : '')+'" onclick="goToPage('+p+')">'+p+'</span>';
    }
  });

  html += '<span class="tps-pagination-next'+(currentPage >= totalPages ? ' disabled' : '')+'" onclick="goToPage('+(currentPage+1)+')">&rsaquo;</span>';

  jQuery('#tps_pagination_section').html(html);
}

function getPaginationRange(current, total){
  var delta = 1;
  var range = [];
  for(var i = Math.max(2, current - delta); i <= Math.min(total - 1, current + delta); i++){
    range.push(i);
  }
  if(current - delta > 2){ range.unshift('...'); }
  if(current + delta < total - 1){ range.push('...'); }
  range.unshift(1);
  if(total > 1){ range.push(total); }
  return range;
}

/*** Pagination: go to a specific page ***/
function goToPage(pageNum){
  emptyResultDiv();
  var totalPages = parseInt(jQuery('#total_pages').val()) || 1;
  pageNum = parseInt(pageNum);
  if(pageNum < 1 || pageNum > totalPages) return;

  jQuery('#page_no').val(pageNum);
  graphqlDataCall();
  setTimeout(() => {
    focusFirstRowOnDiamondLoad();  
  }, 500);
}

/*** Focus on Fisrt Row On Diamond Load ***/
function focusFirstRowOnDiamondLoad(){
  var viewType = getViewType();
  var $firstItem = $('.tps-all-diamond-data .tps-diamondlist-result-' + viewType + '-view-items-list')
      .find('.tps-diamondlist-result-' + viewType + '-view-item')
      .first();

  if ($firstItem.length) {
      $('html, body').animate({
          scrollTop: $firstItem.offset().top - 140
      }, 'slow');
  }
}
/*** End ***/

/* Hand Slider*/ 
function diamonddetailsFourCSection(diamondData){
  var diamondType = diamondData.diamondType;
  var diamondcarat = parseFloat(diamondData.caratWeight);
  var diamondshape = diamondData.shape.toLowerCase();
  $(".tps-diamond-info-card-carat-weight .tps-selected-value").html(diamondData.caratWeight+' ct.');
  
  if(diamondData.fancyColor == ''){
    $(".tps-diamond-info-card-color .tps-selected-value").html(diamondData.color);  

    $(".tps-diamond-info-card-color .tps-tab-btn").each(function () {
        if ($(this).data("title") == diamondData.color) {
            $(this).trigger("click");           
        }
    });
  
    $(".tps-diamond-info-card-fancy-color").parent().remove();      
  }else{      
    $(".tps-diamond-info-card-fancy-color .tps-selected-value").html(diamondData.flourIntensity);
    $(".tps-diamond-info-card-fancy-color .tps-tab-btn").each(function () {
     
        var tabValue = $(this).data("title").toString().trim().toLowerCase();
        var targetValue = diamondData.flourIntensity.toString().trim().toLowerCase();
        if (tabValue === targetValue) {
            $(this).trigger("click");
            return false; // stop loop after match
        }
    });
    $(".tps-diamond-info-card-color").parent().remove();
  }    

  if(diamondData.shape == "Round"){
    var diamondCut = diamondData.cut;
    $(".tps-diamond-info-card-cut .tps-selected-value").html(diamondCut); 

    $(".tps-diamond-info-card-cut .tps-tab-btn").each(function () {
        var tabValue = $(this).data("title").toString().trim().toLowerCase();
        var targetValue = diamondCut.toString().trim().toLowerCase();

        if (tabValue === targetValue) {
            $(this).trigger("click");
        }
    });    
  }else{
    $(".tps-diamond-info-card-cut").parent().remove();
  }      

  $(".tps-diamond-info-card-clarity .tps-selected-value").html(diamondData.clarity); 
  $(".tps-diamond-info-card-clarity .tps-tab-btn").each(function () {
      if ($(this).data("title") == diamondData.clarity) {
          $(this).trigger("click");
      }
  });
}
$(document).on("click", ".tps-tab-btn", function () {
    var $card = $(this).closest(".tps-card-body");

    $card.find(".tps-tab-btn").removeClass("active");
    $(this).addClass("active");

    $card.find(".tps-main-image").attr("src", $(this).data("image"));
    $card.find(".tps-tab-description").html($(this).data("description"));
});
/*** Get Gallery Hand Slider Layout ***/
function getGalleryHandSliderLayout(diamondData,imageUrls,handDiamondImage) {
  var diamondHandSliderImage = [];

  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {   
    var handSliderDiamondImage = 'hand_slider_'+diamondData.shape.toLowerCase()+'_diamond';
    if(diamondImage.includes(handSliderDiamondImage)){    
      diamondHandSliderImage.push(diamondImage);
    }
  });

  handSliderHtml = '';
  handSliderHtml += '<div class="tps-diamond-hand-slider">';
  handSliderHtml += '<img id="tps-gallery-thumb-white" class="tps-gallery-hand-slider-white" src="'+imageUrls.handSliderWhite+'" title="Hand slider white image" alt="Hand slider white image" height="auto" width="auto">';
  handSliderHtml += '<span class="tps-hand-diamond-image"><img id="tps-gallery-hand-diamond-image" class="tps-gallery-hand-diamond-image" src="'+diamondHandSliderImage[0]+'" title="Hand slider diamond" alt="Hand slider diamond" height="auto" width="auto"></span>';
  handSliderHtml += '</div>';   

  handSliderHtml += '<div class="tps-diamond-hand-carat-slider">';
  handSliderHtml += '<span class="left-slide">0.20 ct.</span>';
  handSliderHtml += '<span class="right-slide">10 ct.</span>';
  handSliderHtml += '<div id="hand-carat-slider" class="caratlearnmore"></div>';  
  handSliderHtml += '<div class="min-carat-detail" id="min_carat_detail"></div>';
  handSliderHtml += '</div>';

  setTimeout(function(){
    hand_carat_slider_render(diamondData.caratWeight);
    hand_color_slider_render();
  }, 1000);
  
  return handSliderHtml;   
}
/*** End ***/

/*** Rendar Hand & Carat Slider Start ***/
function renderSliders(diamondCarat) {
    hand_carat_slider_render(diamondCarat);
    hand_color_slider_render();
}
/*** Rendar Hand & Carat Slider End ***/

/*** Gallery Hand Color Slider ***/
function hand_color_slider_render() {
  $("#hand-color-slider").slider({
          step:0.01,
          min: 0.00,
          max: 1.00,
          value: 0.50,
          slide: function(event, ui) {
             var diamondcarat = ui.value;             
             $('#tps-gallery-thumb-black').css('opacity', diamondcarat);              
          },
          change: function(event, ui) {            
            var diamondcarat = ui.value;
            $('#tps-gallery-thumb-black').css('opacity', diamondcarat);  
          },
  });
}
/*** End ***/

/*** Gallery Hand Carat Slider ***/
function hand_carat_slider_render(diamondCarat) {
  const dpiDesktop = 96;        // Common desktop DPI
  const dpiIpad = 264;          // iPad Pro PPI
  const dpiIpadMini = 326;      // iPad Mini PPI
  const dpiHighResPhone = 450;  // High-resolution phone (like iPhone)  
  var diamondcarat = diamondCarat;
      
  $("#hand-carat-slider").slider({
            step: 0.001,
            min: 0.20,
            max: 10,
            value: diamondcarat,
            create: function() {         
                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);

                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
              
                jQuery('#min_carat_detail').appendTo(jQuery('#hand-carat-slider a').get(0));
                jQuery('#hand-carat-slider').slider("value", diamondcarat);  
            },
            slide: function(event, ui) {    
                var diamondcarat = ui.value; 
              
                var delay = function() {
                    var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);

                    $('#tps-gallery-hand-diamond-image').css({
                      'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                      'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                    });

                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");
                };
                setTimeout(delay, 5);
         },
        change: function(event, ui) {              
                var diamondcarat = ui.value;

                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);
                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
          
                var delay = function() {
                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");                         
                };
                setTimeout(delay, 600);
         },
    });
}
/*** Function To Convert Carat Weight To Diamond Diameter In mm (adjusted for visual purposes) Start ***/
function caratToMm(caratWeight) {
    return Math.cbrt(caratWeight / 0.0061).toFixed(2); // Return the size in mm
}
/*** Function To Convert Carat Weight To Diamond Diameter In mm (adjusted for visual purposes) End ***/

/*** Function To Convert Millimeters To Pixels Based On Device DPI (or PPI) Start ***/
function mmToPixels(mm, dpi) {
    return ((dpi * mm) / 25.4).toFixed(2); // Return size in pixels rounded to 2 decimals
}
/*** Function To Convert Millimeters To Pixels Based On Device DPI (or PPI) End ***/

/*** Function To Convert Carats To Pixel Size Based On Device DPI Start ***/
function caratToPixelSize(caratWeight, dpi) {
    // Step 1: Convert carat to millimeters
    const mmSize = caratToMm(caratWeight);
    
    // Step 2: Convert millimeters to pixels based on device DPI
    let pixelSize = mmToPixels(mmSize, dpi);
    
    // Optional: Apply scaling factor for visual purposes
    // let scalingFactor = 2; // Adjust this factor based on the size you want
    // pixelSize *= scalingFactor;
    
    // return pixelSize;
    return pixelSize *= 1, pixelSize;
}
/*** Function To Convert Carats To Pixel Size Based On Device DPI End ***/
/*** End ***/


/*** Get Carta Weight Hand Slider Tooltip Popup Layout ***/
function getGalleryHandSliderLayout(imageUrls) {  
  var diamondHandSliderImage = [];

  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {   
    var handSliderDiamondImage = 'hand_slider_oval_diamond';
    if(diamondImage.includes(handSliderDiamondImage)){    
      diamondHandSliderImage.push(diamondImage);
    }
  });

  handSliderHtml = '';
  handSliderHtml += '<div class="tps-diamond-hand-slider">';
  handSliderHtml += '<img id="tps-gallery-thumb-white" class="tps-gallery-hand-slider-white" src="'+imageUrls.handSliderWhite+'" title="Hand slider white image" alt="Hand slider white image" height="auto" width="auto">';
  handSliderHtml += '<span class="tps-hand-diamond-image"><img id="tps-gallery-hand-diamond-image" class="tps-gallery-hand-diamond-image" src="'+diamondHandSliderImage[0]+'" title="Hand slider diamond" alt="Hand slider diamond" height="auto" width="auto"></span>';
  handSliderHtml += '</div>';   

  handSliderHtml += '<div class="tps-diamond-hand-carat-slider">';
  handSliderHtml += '<span class="left-slide">0.20 ct.</span>';
  handSliderHtml += '<span class="right-slide">10 ct.</span>';
  handSliderHtml += '<div id="hand-carat-slider" class="caratlearnmore"></div>';  
  handSliderHtml += '<div class="min-carat-detail" id="min_carat_detail"></div>';
  handSliderHtml += '</div>';

  setTimeout(function(){
    hand_carat_slider_render('1.0');
  }, 1000);
  
  return handSliderHtml;   
}
/*** End ***/

/*** Hand Carat Slider ***/
function hand_carat_slider_render(diamondCarat) {
  const dpiDesktop = 96;        // Common desktop DPI
  const dpiIpad = 264;          // iPad Pro PPI
  const dpiIpadMini = 326;      // iPad Mini PPI
  const dpiHighResPhone = 450;  // High-resolution phone (like iPhone)  
  var diamondcarat = diamondCarat;
      
  $("#hand-carat-slider").slider({
            step: 0.001,
            min: 0.20,
            max: 10,
            value: diamondcarat,
            create: function() {         
                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);

                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
              
                jQuery('#min_carat_detail').appendTo(jQuery('#hand-carat-slider a').get(0));
                jQuery('#hand-carat-slider').slider("value", diamondcarat);  
            },
            slide: function(event, ui) {    
                var diamondcarat = ui.value; 
              
                var delay = function() {
                    var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);

                    $('#tps-gallery-hand-diamond-image').css({
                      'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                      'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                    });

                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");
                    jQuery('.tps-diamond-info-card-carat-weight .tps-selected-value').html(ui.value.toFixed(2)+" ct."); 
                };
                setTimeout(delay, 5);
         },
        change: function(event, ui) {              
                var diamondcarat = ui.value;

                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);
                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
          
                var delay = function() {
                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");      
                    jQuery('.tps-diamond-info-card-carat-weight .tps-selected-value').html(ui.value.toFixed(2)+" ct.");  
                };
                setTimeout(delay, 600);
         },
    });
}
/*** End ***/

/*** Loose Diamond Add To Bag Start ***/
function addToBagDiamond(diamond_type,diamond_id,diamond_image){     
  var diamondAddToCart = labDiamondAddToCart;
  var buttonId = '.tps-add-to-bag-diamond-'+diamond_id;  
  jQuery(buttonId).addClass('tps-loading');
        
  //query parameters for graphql diamond add to cart call
  var postdata = JSON.stringify({ query:`{
                  ${diamondAddToCart}(diamondId: "` +
              diamond_id +
              `", diamondType:"` +
              diamond_type +
              `")
                  {      
                    status
                     code
                     message                       
                     productId
                     variantId                     
                  }
                  }
                  `});     

     jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) {   
       
        var variant_id = response?.data?.diamondAddToCart?.variantId; 
                
        setTimeout(function(){ 
          // var productSku = [];            
          jQuery.getJSON('/cart.js', function(cart) {
            var diamondExists = false;
            if(cart.items != '' ){                     
              $(cart.items).each(function(index, value) { 
                  var cartSku = value.sku || '';
                  var diamondSku = String(diamond_id);

                  // Case 1: Cart SKU is exactly the diamond SKU
                  if (cartSku === diamondSku) {
                      diamondExists = true;
                      return false;
                  }

                  // Case 2: Cart SKU is a product SKU containing the diamond SKU
                  var skuParts = cartSku.split('-');

                  if ($.inArray(diamondSku, skuParts) !== -1) {
                      diamondExists = true;
                      return false;
                  }                                   
              });
                
              jQuery(buttonId).removeClass('tps-loading');            
                              
              setTimeout(function(){ 
              if (diamondExists) {
                alert(translations.titleProductAlreadyInCart);                  
                jQuery(buttonId).removeClass('tps-loading');            
              }else{                        
                addtocart(variant_id,buttonId);
              }
            }, 50);                    
            }else{
              addtocart(variant_id,buttonId);
            }              
          });    
        }, 1500); 
      },
      error: function (xhr, ajaxOptions, thrownError) {
         alert(xhr.status);
         alert(thrownError);                     
          jQuery(buttonId).removeClass('tps-loading');            
       }
    }); 
}
  
function addtocart(add_id,buttonId){   
  jQuery.post('/cart/add.js', {
    quantity:1,
    id: add_id,
  });

  setTimeout(function(){
    window.location.href = "/cart";
  }, 1000);  

  jQuery(buttonId).removeClass('tps-loading'); 
}
/*** Loose Diamond Add To Bag End ***/

/*** Mobile Diamond Quick View Popup Start ***/
function openDiamondQuickViewPopup($anchor) {
  var diamondId = $anchor.attr('data-id');
  var diamondPage = $anchor.attr('data-page');
  var detailUrl = $anchor.attr('href');
  var title = $anchor.attr('data-title');
  var price = $anchor.attr('data-price');
  var finalPrice = $anchor.attr('data-final-price');
  var comparePrice = $anchor.attr('data-comp-price');
  var savingPrice = $anchor.attr('data-saving-price');
  var carat = $anchor.attr('data-carat');
  var color = $anchor.attr('data-color');
  var clarity = $anchor.attr('data-clarity');
  var cut = $anchor.attr('data-cut');
  var lab = $anchor.attr('data-lab');
  var certUrl = $anchor.attr('data-cert-url');
  var image = $anchor.attr('data-image');
  var shape = $anchor.attr('data-shape');
  var diamondType = $anchor.attr('data-type');
  var showChoose = $anchor.attr('data-show-choose');

  var metaHtml = '';
  if(carat != '' && carat != undefined){
    metaHtml += '<div class="tps-qv-meta-item"><span class="tps-qv-meta-value">'+carat+'</span><span class="tps-qv-meta-label">Carat</span></div>';
  }
  if(color != '' && color != undefined){
    metaHtml += '<div class="tps-qv-meta-item"><span class="tps-qv-meta-value">'+color+'</span><span class="tps-qv-meta-label">Color</span></div>';
  }
  if(clarity != '' && clarity != 'NA' && clarity != undefined){
    metaHtml += '<div class="tps-qv-meta-item"><span class="tps-qv-meta-value">'+clarity+'</span><span class="tps-qv-meta-label">Clarity</span></div>';
  }
  if(cut != '' && cut != 'NA' && cut != undefined){
    metaHtml += '<div class="tps-qv-meta-item"><span class="tps-qv-meta-value">'+cut+'</span><span class="tps-qv-meta-label">Cut</span></div>';
  }

  var certHtml = '';
  if(lab != '' && lab != undefined && lab != 'undefined'){
    certHtml += '<div class="tps-qv-certificate tps-qv-certificate-'+lab+'">';
    certHtml += '<span class="tps-qv-certificate-lab">'+lab+' - Lab Diamond</span>';
    if(certUrl != '' && certUrl != undefined){
      certHtml += '<a href="'+certUrl+'" target="_blank" rel="noopener" class="tps-qv-certificate-link">View Certificate</a>';
    }
    certHtml += '</div>';
  }

  var popupHtml = '';
  popupHtml += '<div class="tps-diamond-quickview-overlay"></div>';
  popupHtml += '<div class="tps-diamond-quickview-card">';
  popupHtml += '<span class="tps-diamond-quickview-close">&times;</span>';
  popupHtml += '<div class="tps-qv-image-wrap"><img src="'+image+'" alt="'+title+'"></div>';
  popupHtml += '<div class="tps-qv-title-price-row">';
  popupHtml += '<span class="tps-qv-title">'+title+'</span>';
  popupHtml += '<span class="tps-qv-price">'+price;
  if(comparePrice && savingPrice){
    popupHtml += '<div class="tps-qv-compare-sec"><span class="tps-diamondlist-item-comp-price">'+comparePrice+'</span><span class="tps-diamondlist-item-save-price"><label>Save</label>'+savingPrice+'</span></div>';
  }
  popupHtml += '</span>';
  popupHtml += '</div>';
  popupHtml += '<div class="tps-qv-meta-row">'+metaHtml+'</div>';
  popupHtml += certHtml;
  popupHtml += '<div class="tps-qv-buttons-row">';
  popupHtml += '<a href="'+detailUrl+'" class="tps-diamondlist-detail-view-btn tps-qv-more-info-btn" data-id="'+diamondId+'" data-page="'+diamondPage+'">'+translations.titleMoreInfo+'</a>';
  popupHtml += '<button class="tps-diamondlist-item-detail-add-to-bag tps-qv-choose-btn tps-add-to-bag-diamond tps-add-to-bag-diamond-'+diamondId+'" data-id="'+diamondId+'" onclick="addToBagDiamond(`'+diamondType+'`,`'+diamondId+'`,`'+image+'`);">'+translations.titleAddToBag+'</button>';
  popupHtml += '</div>';
  popupHtml += '</div>';

  if(jQuery('#tps_diamond_quickview_popup').length == 0){
    jQuery('body').append('<div id="tps_diamond_quickview_popup" class="tps-diamond-quickview-popup"></div>');
  }
  jQuery('#tps_diamond_quickview_popup').html(popupHtml).addClass('active');
  jQuery('body').addClass('tps-quickview-open');
}

$(document).on('click', '.tps-diamond-quickview-close, .tps-diamond-quickview-overlay', function(){
  closeDiamondQuickViewPopup();
});

function closeDiamondQuickViewPopup(){
  jQuery('#tps_diamond_quickview_popup').removeClass('active').empty();
  jQuery('body').removeClass('tps-quickview-open');
}
/*** Mobile Diamond Quick View Popup End ***/


